
jQuery.noConflict();


jQuery(document).on('woocommerce_variation_has_changed', function () {
    var variation_id = jQuery('.variation_id').val();
    var variation_data = jQuery('.variations_form').attr('data-product_variations')
    variation_data = JSON.parse(variation_data)
    jQuery.each(variation_data, function (i, data) {
        if (variation_id == data.variation_id) {
            var max_qty = data.max_qty;
            var html = '';
            for (i = 1; i <= max_qty; i++) {
                html += '<option value="' + i + '">' + i + '</option>';
            }
            console.log("Data", data, max_qty);
            if (max_qty == '') {
                jQuery('.quantity_select').hide()
                setTimeout(function () {
                    jQuery('.single_add_to_cart_button').attr("disabled", true);
                    jQuery('.single_add_to_cart_button').html('Out of Stock')
                    jQuery('.single_add_to_cart_button').hide();
                    jQuery('.email_out_of_stock').show()
                }, 200);
            } else {
                jQuery('.quantity_select').show()
                setTimeout(function () {
                    jQuery('.single_add_to_cart_button').attr("disabled", false);
                    jQuery('.single_add_to_cart_button').html('Aggiungi al Carrello')
                    jQuery('.single_add_to_cart_button').show();
                    jQuery('.email_out_of_stock').hide()
                }, 200)
            }
            // jQuery('select[name="quantity"]').html(html).select2()

        }
    })
})

// polyfill
window.requestAnimationFrame = (function () {
    return (
        window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        function (callback) {
            window.setTimeout(callback, 1000 / 60);
        }
    );
})();

// Maquee Slider
var speed = 8000;
(function currencySlide() {
    var currencyPairWidth = jQuery("span:first-child").outerWidth();
    jQuery(".marquee").animate(
        { marginLeft: -currencyPairWidth },
        speed,
        "linear",
        function () {
            jQuery(this)
                .css({ marginLeft: 0 })
                .find("span:last")
                .after(jQuery(this).find("span:first"));
        }
    );
    requestAnimationFrame(currencySlide);
})();

// Product tabs
if (document.querySelector('#tabs')) {
    jQuery(document).ready(function ($) {
        $('#tabs li a:not(:first)').addClass('inactive');
        $('.info-product').hide();
        $('.info-product:first').show();

        $('#tabs li a').click(function () {
            var t = $(this).attr('id');
            if ($(this).hasClass('inactive')) { //this is the start of our condition 
                $('#tabs li a').addClass('inactive');
                $(this).removeClass('inactive');

                $('.info-product').hide();
                $('#' + t + 'C').fadeIn('slow');
            }
        });
    });
}

// Sidebar
if (document.querySelector('#product-summary')) {
    var sidebar = new StickySidebar('#product-summary', {
        containerSelector: '#main-content__product',
        innerWrapperSelector: '.product-summary-wrapper',
        topSpacing: 20,
        bottomSpacing: 20,
        resizeSensor: true,
        minWidth: 980
    });
}

// Full Page
if (document.querySelector('#fullpage')) {
    jQuery('#fullpage').fullpage({
        scrollHorizontally: true,
        navigation: true,
        scrollOverflow:true,
    });
}
// Shop Navigation
jQuery(".cat-nav").click(function () {
    jQuery(".cat-nav-wrap").slideToggle();
    jQuery(".brand-nav-wrap").slideUp();
});

jQuery(".brands-nav").click(function () {
    jQuery(".brand-nav-wrap").slideToggle();
    jQuery(".cat-nav-wrap").slideUp();
});

// Slider
if (document.querySelector('.swiper-loop-product')) {
    var swiper = new Swiper('.swiper-loop-product', {
        watchOverflow: true,
        slidesPerView: 1.7,
        spaceBetween: 4,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="dots-slider ' + className + '"></span>';
            },
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                spaceBetween: 4,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 4,
            },
            1024: {
                slidesPerView: 4,
                spaceBetween: 4,
            },
        }
    });
}

if (document.querySelector('.store-gallery-carousel')) {
  var swiper = new Swiper('.store-gallery-carousel', {
      watchOverflow: true,
      slidesPerView: 1.7,
      spaceBetween: 4,
      observer: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet: function (index, className) {
              return '<span class="dots-slider ' + className + '"></span>';
          },
      },
      breakpoints: {
          640: {
              slidesPerView: 2,
              spaceBetween: 4,
          },
          768: {
              slidesPerView: 3,
              spaceBetween: 4,
          },
          1024: {
              slidesPerView: 4,
              spaceBetween: 4,
          },
      }
  });
}

// Mobile Nav
jQuery("#nav-icon3").click(function () {
    jQuery(this).toggleClass('open');
    jQuery('.fullscreen-nav').toggleClass('open');
    jQuery('body').toggleClass('noScroll');
});

jQuery("a.smooth-scroll").on('click', function (event) {
    if (this.hash !== "") {
        event.preventDefault();
        var hash = this.hash;
        jQuery('html, body').animate({
            scrollTop: $(hash).offset().top
        }, 800, function () {
            window.location.hash = hash;
        });
    }
});

(function($) {
  $.fn.timeline = function() {
    var selectors = {
      id: $(this),
      item: $(this).find(".timeline-item"),
      activeClass: "timeline-item--active",
      img: ".timeline__img"
    };
    
    // Aggiungi la classe attiva al primo elemento
    selectors.item.eq(0).addClass(selectors.activeClass);
    
    // Imposta l'immagine di sfondo del primo elemento
    selectors.id.css(
      "background-image",
      "url(" +
        selectors.item
          .first()
          .find(selectors.img)
          .attr("src") +
        ")"
    );
    
    var itemLength = selectors.item.length;
    var offset = 150; // Offset di 100px
    
    $(window).scroll(function() {
      var max, min;
      var pos = $(this).scrollTop() + offset; // Aggiungi l'offset alla posizione di scroll
      
      selectors.item.each(function(i) {
        min = $(this).offset().top;
        max = $(this).height() + $(this).offset().top;
        var that = $(this);
        
        if (i == itemLength - 2 && pos > min + $(this).height() / 2) {
          selectors.item.removeClass(selectors.activeClass);
          selectors.id.css(
            "background-image",
            "url(" +
              selectors.item
                .last()
                .find(selectors.img)
                .attr("src") +
              ")"
          );
          selectors.item.last().addClass(selectors.activeClass);
        } else if (pos <= max - 40 && pos >= min) {
          selectors.id.css(
            "background-image",
            "url(" +
              $(this)
                .find(selectors.img)
                .attr("src") +
              ")"
          );
          selectors.item.removeClass(selectors.activeClass);
          $(this).addClass(selectors.activeClass);
        }
      });
    });
  };
})(jQuery);

jQuery("#timeline-1").timeline();

jQuery(document).ready(function ($) {
    //caches a jQuery object containing the header element
    var filter = $(".filter-section")
    $(window).scroll(function () {
        var scroll = $(window).scrollTop();
        if ((jQuery(window).width() >= 992)) {
            if (scroll >= 75) {
                filter.addClass("scroll");
            } else {
                filter.removeClass("scroll");
            }
        }
        if ((jQuery(window).width() <= 991)) {
            if (scroll >= 2) {
                filter.addClass("scroll");
            } else {
                filter.removeClass("scroll");
            }
        }
    });
});

jQuery('.site-mini-cart').click(function () {
    jQuery('.site-cart').addClass("active");
    jQuery('body').addClass("noScroll");
});
jQuery('.close-site-cart').click(function () {
    jQuery('.site-cart').removeClass("active");
    jQuery('body').removeClass("noScroll");
});
jQuery('.open_filter_attribute').click(function () {
    jQuery('.filter_sidebar_attribute').addClass("active");
    jQuery('body').addClass("noScroll");
});
jQuery('.open_filter_orderby').click(function () {
    jQuery('.filter_sidebar_orderby').addClass("active");
    jQuery('body').addClass("noScroll");
});
jQuery('.close_filter').click(function () {
    jQuery('.filter_sidebar').removeClass("active");
    jQuery('body').removeClass("noScroll");
});
jQuery('#find-product').click(function () {
    jQuery(this).toggleClass("active");
    jQuery('body').toggleClass("noScroll");
    jQuery('.search-form').toggleClass("active");
    jQuery('.overlay-search').toggleClass("active");
    if (!jQuery('.search-form').hasClass('active')) {
        jQuery('.search-result').removeClass("active");
        jQuery('body').removeClass("noScroll");
    }
});
jQuery('#find-product-mobile').click(function () {
    jQuery(this).toggleClass("active");
    jQuery('body').toggleClass("noScroll");
    jQuery('.overlay-search').toggleClass("active");
    jQuery('.search-form').toggleClass("active");
    if (!jQuery('.search-form').hasClass('active')) {
        jQuery('.search-result').removeClass("active");
        jQuery('body').removeClass("noScroll");
    }
});

// Accordion

var acc = document.getElementsByClassName("filter-title");
var i;

for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
    });
}


jQuery(document).on('click', '.apply_button', function () {
    jQuery('.filter_counter_total').html("(" + jQuery('.filter_attribute:checked').length + ")");
    jQuery('.loader-search-wrap').css('display', 'flex');
    // jQuery('.filter-content').hide();
    var total_filter = 0;
    jQuery('.filter_count').each(function () {
        var id = jQuery(this).attr('data-id');
        var count = jQuery('input[name="' + id + '"]:checked').length;
        if (count > 0) {
            total_filter = total_filter + 1;
            jQuery(this).html('(' + count + ')');

        } else {
            jQuery(this).html('');
        }

    })
    if (total_filter > 0) {
        jQuery('.clear_filters').removeClass('hidden').addClass('visibile')
    } else {
        jQuery('.clear_filters').removeClass('visibile').addClass('hidden')
    }
    var is_append = false;
    // jQuery('#filtri_ajax_content_new').hide()
    if (jQuery(this).hasClass('new_page_link')) {
        var $page = jQuery(this).attr('data-id');
    } else if (jQuery(this).hasClass('load_more_button')) {
        var $page = parseInt(jQuery('#queried_page').val()) + 1;
        is_append = true;
    } else {
        var width = jQuery(window).width();
        //var $page = jQuery('#queried_page').val();    
        $page = 1;
        var $id = jQuery(this).attr('data-id');

    }
    var filter_by = jQuery('input[name="filter_by"]:checked').val();

    jQuery('.filter_by_selected').html(jQuery('input[name="filter_by"]:checked').attr('data-label'))

    if (filter_by === undefined) {
        filter_by = 'relevance';
    }
    var size = jQuery('#page_size').val();
    var filter_by_relevance = jQuery('#filter_new input[name="filter_by_relevance"]:checked').val();
    let filter_by_price = [];
    jQuery('input[name="filter_by_price"]:checked').each(function (i) {
        filter_by_price[i] = jQuery(this).val()
    });
    let fixed_filter = jQuery('#fixed_filter').val()


    console.log(jQuery('.filter_attribute:checked'))
    jQuery('.selected_filter_term_wrap').html('')
    jQuery('.filter_attribute:checked').each(function () {
        jQuery('.selected_filter_term_wrap').append(
            jQuery('<div data-slug="' + jQuery(this).attr('data-id') + '" class="selected_filter" >' + jQuery(this).attr('data-name') + '<span>x</span></div>'))
    })
    jQuery.ajax({
        type: "post",
        url: my_ajax_object.ajax_url,
        // url:"http://woodenstore.local:8888/wp-admin/admin-ajax.php",
        data: {
            action: "as_filter_product",
            page: 1,
            size: size,
            cat_id: jQuery('#cat_id').val(),
            brand_id: jQuery('#brand_id').val(),
            filter_by: filter_by,
            filter_by_attribute: (jQuery('.filter_attribute:checked').serializeArray()),
            is_append: is_append,
            fixed_filter: fixed_filter,
            page_link: jQuery('#page_link').val()
        },

        error: function (data) {
            console.log(data)
        },
    }).done(function (data) {
        if (is_append) {
            jQuery('#filtri_ajax_content_new').append(data).show();
            jQuery('#queried_page').val($page);

        } else {
            jQuery('#filtri_ajax_content_new').html(data).show();
            // var scroll = new SmoothScroll('[data-easing="easeInQuart"]', {
            //     speed: 500,
            //     speedAsDuration: true
            // });
            // var anchor = document.querySelector('#products-loop');
            // scroll.animateScroll(anchor);
        }

        jQuery('.loader-search-wrap').fadeOut();
        setTimeout(function () {
            jQuery('.product_is_loading').hide();
        }, 1000)

        jQuery('.filter_sidebar').removeClass("active");
        jQuery('body').removeClass("noScroll");
        // console.log(jQuery('#queried_page').val())
        // console.log(jQuery('#total_pages').val())
        // console.log(jQuery('#queried_page').val() >= jQuery('#total_pages').val())
        // if (parseInt(jQuery('#queried_page').val()) >= parseInt(jQuery('#total_pages').val())) {
        //     jQuery('.load_more_button').hide()
        // } else {
        //     jQuery('.load_more_button').show()
        // }

    });



})

jQuery(document).on('click', '#nav-icon3', function () {
    if (jQuery('body').hasClass('menu-open-custom')) {
        jQuery('.slide-menu__control[data-action="close"]').trigger('click')
        jQuery('body').toggleClass('menu-open-custom')
    } else {
        jQuery('.slide-menu__control[data-action="open"]').trigger('click')
        jQuery('body').toggleClass('menu-open-custom')
    }
})

jQuery(document).on('click', '.filter-option label', function () {
    jQuery(this).toggleClass('active');
});





(function (o) { var t = { url: !1, callback: !1, target: !1, duration: 120, on: "mouseover", touch: !0, onZoomIn: !1, onZoomOut: !1, magnify: 1 }; o.zoom = function (t, n, e, i) { var u, c, a, r, m, l, s, f = o(t), h = f.css("position"), d = o(n); return t.style.position = /(absolute|fixed)/.test(h) ? h : "relative", t.style.overflow = "hidden", e.style.width = e.style.height = "", o(e).addClass("zoomImg").css({ position: "absolute", top: 0, left: 0, opacity: 0, width: e.width * i, height: e.height * i, border: "none", maxWidth: "none", maxHeight: "none" }).appendTo(t), { init: function () { c = f.outerWidth(), u = f.outerHeight(), n === t ? (r = c, a = u) : (r = d.outerWidth(), a = d.outerHeight()), m = (e.width - c) / r, l = (e.height - u) / a, s = d.offset() }, move: function (o) { var t = o.pageX - s.left, n = o.pageY - s.top; n = Math.max(Math.min(n, a), 0), t = Math.max(Math.min(t, r), 0), e.style.left = t * -m + "px", e.style.top = n * -l + "px" } } }, o.fn.zoom = function (n) { return this.each(function () { var e = o.extend({}, t, n || {}), i = e.target && o(e.target)[0] || this, u = this, c = o(u), a = document.createElement("img"), r = o(a), m = "mousemove.zoom", l = !1, s = !1; if (!e.url) { var f = u.querySelector("img"); if (f && (e.url = f.getAttribute("data-src") || f.currentSrc || f.src), !e.url) return } c.one("zoom.destroy", function (o, t) { c.off(".zoom"), i.style.position = o, i.style.overflow = t, a.onload = null, r.remove() }.bind(this, i.style.position, i.style.overflow)), a.onload = function () { function t(t) { f.init(), f.move(t), r.stop().fadeTo(o.support.opacity ? e.duration : 0, 1, o.isFunction(e.onZoomIn) ? e.onZoomIn.call(a) : !1) } function n() { r.stop().fadeTo(e.duration, 0, o.isFunction(e.onZoomOut) ? e.onZoomOut.call(a) : !1) } var f = o.zoom(i, u, a, e.magnify); "grab" === e.on ? c.on("mousedown.zoom", function (e) { 1 === e.which && (o(document).one("mouseup.zoom", function () { n(), o(document).off(m, f.move) }), t(e), o(document).on(m, f.move), e.preventDefault()) }) : "click" === e.on ? c.on("click.zoom", function (e) { return l ? void 0 : (l = !0, t(e), o(document).on(m, f.move), o(document).one("click.zoom", function () { n(), l = !1, o(document).off(m, f.move) }), !1) }) : "toggle" === e.on ? c.on("click.zoom", function (o) { l ? n() : t(o), l = !l }) : "mouseover" === e.on && (f.init(), c.on("mouseenter.zoom", t).on("mouseleave.zoom", n).on(m, f.move)), e.touch && c.on("touchstart.zoom", function (o) { o.preventDefault(), s ? (s = !1, n()) : (s = !0, t(o.originalEvent.touches[0] || o.originalEvent.changedTouches[0])) }).on("touchmove.zoom", function (o) { o.preventDefault(), f.move(o.originalEvent.touches[0] || o.originalEvent.changedTouches[0]) }).on("touchend.zoom", function (o) { o.preventDefault(), s && (s = !1, n()) }), o.isFunction(e.callback) && e.callback.call(a) }, a.setAttribute("role", "presentation"), a.alt = "", a.src = e.url }) }, o.fn.zoom.defaults = t })(window.jQuery);

jQuery(".store-checkout label").click(function () {
    jQuery('.store-checkout label').removeClass('active');
    jQuery(this).addClass('active');
})
jQuery(document).on('click', '.variable-item', function () {


    jQuery('.button-variable-item').removeClass('selected');
    jQuery(this).addClass('selected');
    jQuery('#pa_sizes').val(jQuery(this).attr('data-value')).trigger('change')
});




jQuery(document).on('click', '.postid-26312 .button-variable-item', function () {


    jQuery('.button-variable-item').removeClass('selected');
    jQuery(this).addClass('selected');
    jQuery('#pa_importo-gift-card').val(jQuery(this).attr('data-value')).trigger('change')
});




(function ($) {

    $(document).on('click', '.single_add_to_cart_button:not(.disabled)', function (e) {
        e.preventDefault();

        var $thisbutton = $(this),
            $form = $thisbutton.closest('form.cart'),
            id = $thisbutton.val(),
            product_qty = $form.find('input[name=quantity]').val() || 1,
            product_id = $form.find('input[name=product_id]').val() || id,
            variation_id = $form.find('input[name=variation_id]').val() || 0;

        var data = {
            action: 'woocommerce_ajax_add_to_cart',
            product_id: product_id,
            product_sku: '',
            quantity: product_qty,
            variation_id: variation_id,
            wc_gc_giftcard_to_multiple: $form.find('input[name=wc_gc_giftcard_to_multiple]').val(),
            wc_gc_giftcard_from: $form.find('input[name=wc_gc_giftcard_from]').val(),
            wc_gc_giftcard_message: $form.find('input[name=wc_gc_giftcard_message]').val(),
            wc_gc_giftcard_delivery: $form.find('input[name=wc_gc_giftcard_delivery]').val(),
            _wc_gc_giftcard_delivery_gmt_offset: $form.find('input[name=_wc_gc_giftcard_delivery_gmt_offset]').val(),
            wc_gc_giftcard_delivery: $form.find('input[name=wc_gc_giftcard_delivery]').val(),
            security: $form.find('input[name=security]').val(),

        };

        $(document.body).trigger('adding_to_cart', [$thisbutton, data]);
        if ($form.find('input[name=variation_id]').length > 0 && variation_id == 0) {
            return false;
        }
        $.ajax({
            type: 'post',
            url: wc_add_to_cart_params.ajax_url,
            data: data,
            beforeSend: function (response) {
                $thisbutton.removeClass('added').addClass('loading');
            },
            complete: function (response) {
                $thisbutton.addClass('added').removeClass('loading');
                $('.site-cart').addClass('active');
            },
            success: function (response) {
                console.log(response);
                if (response.error & response.product_url) {
                    window.location = response.product_url;
                    return;
                } else {




                    $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);

                    $.each(response.fragments, function (key, value) {
                        $(key).replaceWith(value);
                        $(key).stop(true).css('opacity', '1');
                    });
                    console.log('wwww')
                    // jQuery('.mini_cart_quantity').select2()
                }
            },
        });

        return false;
    });

    jQuery(document).on('change', '.mini_cart_quantity', function () {
        jQuery('.loader-search-wrap').css('display', 'flex');
        $.ajax({
            type: 'post',
            url: wc_add_to_cart_params.ajax_url,
            data: {
                action: 'mini_cart_change_quanity',
                key: jQuery(this).attr('data-id'),
                quantity: jQuery(this).val()
            },
            success: function (response) {
                $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash]);

                $.each(response.fragments, function (key, value) {
                    $(key).replaceWith(value);
                    $(key).stop(true).css('opacity', '1');
                });
                //   jQuery('.mini_cart_quantity').select2()
                jQuery('.loader-search-wrap').fadeOut();
            },
        });
    })
    jQuery(document).on('change', '.woo-variation-raw-select', function () {
        setTimeout(function () {
            if (jQuery('.single_add_to_cart_button').hasClass('disabled')) {
                jQuery('.single_add_to_cart_button').html('Out of Stock')
                jQuery('.email_out_of_stock').show()
            } else {
                jQuery('.single_add_to_cart_button').html('Aggiungi al Carrello')
                jQuery('.email_out_of_stock').hide()
            }
        }, 100)
        console.log(jQuery('.variations_form').data())
    });

    jQuery(document).on('click', '#submit_out_stock', function () {
        var $thisbutton = jQuery(this)
        $.ajax({
            type: 'post',
            url: wc_add_to_cart_params.ajax_url,
            data: {
                action: 'add_stock_notification',
                product_id: jQuery('input[name="product_id"]').val(),
                user_email: jQuery('#out_of_stock_email').val()
            },
            beforeSend: function (response) {
                $thisbutton.removeClass('added').addClass('loading');
            },
            complete: function (response) {
                $thisbutton.addClass('added').removeClass('loading');
            },
            success: function (response) {
                console.log(response);

                jQuery('.out_of_stock_success').html(response)
            },
        });
    })
})(jQuery);

jQuery(document).on('keyup', '#search-product', function () {
    jQuery('.search-result').addClass('active');
    jQuery('body').addClass('noScroll');
    var value = jQuery(this).val();
    var verification_nonce = jQuery(this).attr('data_nonce');
    let value_trim = value.replace(/\s/g, '')
    let timeout;
    if (value_trim.length > 2) {
        clearTimeout(timeout);
        timeout = setTimeout(function () {
            jQuery.ajax({
                url: wc_add_to_cart_params.ajax_url,
                type: 'post',
                data: {
                    action: 'ajax_search',
                    search: value,
                    prevent_other: 1,
                    verification_nonce: verification_nonce
                },
                success: function (response) {
                    jQuery('.search-result__wrap').html(response);
                }
            });
        }, 2000);
    } else {
        jQuery('.search-result').removeClass('active');
        // jQuery('body').removeClass('noScroll');     
        jQuery('.search-result__wrap').html('<h3 class="title-ajax-search">Stiamo caricando i risultati...</h3><div class="loader-search simple-circle"></div>');
    }
})

jQuery(document).on('click', '.selected_filter', function (e) {
    e.preventDefault();
    e.stopPropagation();
    console.log(jQuery('#term_id_' + jQuery(this).attr('data-slug')))
    jQuery('label[for="term_id_' + jQuery(this).attr('data-slug') + '"]').removeClass('active')
    jQuery('#term_id_' + jQuery(this).attr('data-slug')).attr('checked', false);
    jQuery('#term_id_' + jQuery(this).attr('data-slug')).attr('checked', "");
    jQuery('#term_id_' + jQuery(this).attr('data-slug'))[0].removeAttribute('checked');
    jQuery('#term_id_' + jQuery(this).attr('data-slug')).prop('checked', false);
    jQuery(this).remove();
    jQuery(this).hide();
    jQuery('.selected_filter[data-slug="' + jQuery(this).attr('data-slug') + '"]').remove()
    jQuery('.apply_button').trigger('click');
})



// Checkout
let timeout = null;
jQuery(document).ready(function () {

    jQuery('.filter_by_selected').html(jQuery('input[name="filter_by"]:checked').attr('data-label'))
    jQuery('.filter_counter_total').html("(" + jQuery('.filter_attribute:checked').length + ")");
    if (jQuery('input[type="radio"][name="ship_to_different_address"]').length) {
        var checked_input = jQuery('input[type="radio"][name="ship_to_different_address"]:checked').trigger('change').attr('id')

        if (checked_input == 'ship-to-different-address-checkbox') {
            if (jQuery('.shipping_method[value="free_shipping:9"]').length) {
                jQuery('.shipping_method[value="free_shipping:9"]').trigger('click')
            }
            // else if (jQuery('.shipping_method[value="local_pickup:11"]').length) {
            //     jQuery('.shipping_method[value="local_pickup:11"]').trigger('click')
            // } 
            else if (jQuery('.shipping_method[value="free_shipping:2"]').length) {
                jQuery('.shipping_method[value="free_shipping:2"]').trigger('click')
            } else if (jQuery('.shipping_method[value="flat_rate:4"]').length) {
                jQuery('.shipping_method[value="flat_rate:4"]').trigger('click')
            } else {
                jQuery('.shipping_method[value="flat_rate:6"]').trigger('click')
            }
        } else {
            if (checked_input == 'local_pickup') {
                jQuery('.shipping_method[value="local_pickup:11"]').trigger('click');
            } else {
                jQuery('.shipping_method[value="wc_brt_fermopoint_shipping_methods_custom:10"]').trigger('click')
                if (jQuery('#brt_zipcode').val() != '') {
                    jQuery('.shipping_method[value="wc_brt_fermopoint_shipping_methods_custom:10"]').trigger('click')
                } else {

                }

            }
        }
    }


    setTimeout(function () {
        jQuery('.variable-items-wrapper li:nth-child(1)').trigger('click')
    }, 1000)

    // jQuery('.mini_cart_quantity').select2()
})
jQuery(document).on('change', 'input[name="payment_method"]', function () {
    updateSelectedPayment()
})
function updateSelectedPayment() {
    jQuery('input[name="payment_method"]').parent().removeClass('active')
    jQuery('input[name="payment_method"]:checked').parent().addClass('active')
}



jQuery(document).on('change', 'input[type="radio"][name="ship_to_different_address"]', function () {
    var checked_input = jQuery('input[type="radio"][name="ship_to_different_address"]:checked').attr('id')
    jQuery('.hide_show_shipping').hide();
    jQuery('.hide_show_shipping[data-id="' + checked_input + '"]').show();

    if (checked_input == 'ship-to-different-address-checkbox') {
        if (jQuery('.shipping_method[value="free_shipping:9"]').length) {
            jQuery('.shipping_method[value="free_shipping:9"]').trigger('click')
        }
        // else if (jQuery('.shipping_method[value="local_pickup:11"]').length) {
        //     jQuery('.shipping_method[value="local_pickup:11"]').trigger('click')
        // } 
        else if (jQuery('.shipping_method[value="flat_rate:4"]').length) {
            jQuery('.shipping_method[value="flat_rate:4"]').trigger('click')
        } else {
            jQuery('.shipping_method[value="flat_rate:6"]').trigger('click')
        }
        validateShipping()
    } else if (checked_input == 'brt_fermopoint') {
        jQuery('.shipping_method[value="wc_brt_fermopoint_shipping_methods_custom:10"]').trigger('click')
        if (jQuery('#brt_zipcode').val() != '') {
            jQuery('.shipping_method[value="wc_brt_fermopoint_shipping_methods_custom:10"]').trigger('click')
            jQuery('.hide_show_shipping[data-id="brt_fermopoint"] div').show();

            initMap();
        }
    } else {
        jQuery('.shipping_method[value="local_pickup:11"]').trigger('click')

        jQuery('#localshipping1').trigger('click')

        if (jQuery('input[name="store_id"]:checked').length == 0) {
            jQuery('.confirm_shipping').attr('disabled', true)
        } else {
            jQuery('.confirm_shipping').attr('disabled', false)
        }
    }
    jQuery(document.body).trigger("update_checkout");
});


jQuery(document).on('change', '#brt_zipcode', function () {
    if (jQuery(this).val() != '') {
        jQuery('.shipping_method[value="wc_brt_fermopoint_shipping_methods_custom:10"]').trigger('click')
        jQuery('.shipping_method[value="wc_brt_fermopoint_shipping_methods_custom:10"]').trigger('change')
        jQuery('.hide_show_shipping[data-id="brt_fermopoint"] div').show();

        initMap();
    }

})
jQuery(document).on('keyup', '#brt_zipcode', function () {
    if ((jQuery(this).val()).length >= 5) {
        jQuery('.shipping_method[value="wc_brt_fermopoint_shipping_methods_custom:10"]').trigger('click')
        jQuery('.shipping_method[value="wc_brt_fermopoint_shipping_methods_custom:10"]').trigger('change')
        jQuery('.hide_show_shipping[data-id="brt_fermopoint"] div').show();

        initMap();
    }

})
jQuery(document).on('change', 'input[name="store_id"]', function () {
    jQuery('.confirm_shipping').attr('disabled', false)
})

jQuery(document).on('click', '.confirm_shipping', function () {
    jQuery('.section-shipping').removeClass('not-filled').removeClass('open');
    jQuery('.section-shipping').addClass('filled').addClass('closed');
    jQuery('.step-1').removeClass('mobile-not-filled').removeClass('mobile-open');
    jQuery('.step-1').addClass('mobile-filled').addClass('mobile-closed');

    if (!jQuery('.section-billing-payment').hasClass('filled')) {
        jQuery('.section-billing-payment').addClass('not-filled').addClass('open');
        jQuery('.section-billing-payment').removeClass('filled').removeClass('closed');
        jQuery('.step-2').addClass('mobile-not-filled').addClass('mobile-open');
        jQuery('.step-2').removeClass('mobile-filled').removeClass('mobile-closed');
    }
    if (jQuery('.section-billing-payment').hasClass('filled') && jQuery('.section-shipping').hasClass('filled')) {
        jQuery('.section-terms-condition').removeClass('disabled')
        jQuery('.step-3').removeClass('mobile-disabled')
    }

    updateShippingSummary();
    updateSelectedPayment()
    validateBilling()
})
jQuery(document).on('click', '.modify_shipping', function () {
    jQuery('.section-shipping').addClass('not-filled').addClass('open');
    jQuery('.section-shipping').removeClass('filled').removeClass('closed');
    jQuery('.step-1').addClass('mobile-not-filled').addClass('mobile-open');
    jQuery('.step-1').removeClass('mobile-filled').removeClass('mobile-closed');
})
jQuery(document).on('click', '.confirm_billing', function () {
    jQuery('.section-billing-payment').removeClass('not-filled').removeClass('open');
    jQuery('.section-billing-payment').addClass('filled').addClass('closed');
    jQuery('.step-2').removeClass('mobile-not-filled').removeClass('mobile-open');
    jQuery('.step-2').addClass('mobile-filled').addClass('mobile-closed');
    if (jQuery('.section-billing-payment').hasClass('filled') && jQuery('.section-shipping').hasClass('filled')) {
        jQuery('.section-terms-condition').removeClass('disabled')
        jQuery('.section-terms-condition').addClass('open').addClass('not-filled')
        jQuery('.step-3').addClass('mobile-not-filled').addClass('mobile-open')
        jQuery('.step-3').removeClass('mobile-disabled')
    }
    updateBillingSummary()
    validateTerms()
})
jQuery(document).on('click', '.modify_billing', function () {
    jQuery('.section-billing-payment').addClass('not-filled').addClass('open');
    jQuery('.section-billing-payment').removeClass('filled').removeClass('closed');
    jQuery('.step-2').addClass('mobile-not-filled').addClass('mobile-open');
    jQuery('.step-2').removeClass('mobile-filled').removeClass('mobile-closed');
    jQuery('.section-shipping').removeClass('not-filled').removeClass('open');
    jQuery('.section-shipping').addClass('filled').addClass('closed');
    jQuery('.step-1').removeClass('mobile-not-filled').removeClass('mobile-open');
    jQuery('.step-1').addClass('mobile-filled').addClass('mobile-closed');
    updateSelectedPayment()
    validateTerms()
})



function updateShippingSummary() {
    var ship_to_different_address = jQuery('input[name="ship_to_different_address"]:checked').val();
    if (ship_to_different_address == 1) {
        jQuery('.shipping_method_title').html('Indirizzo di consegna');
        jQuery('.shipping_method').html('Spedizione Standard');
        var shipping_name = jQuery('#shipping_first_name').val() + ' ' + jQuery('#shipping_last_name').val();
        var shipping_address = jQuery('#shipping_address_1').val() + ' ' + jQuery('#shipping_address_2').val() + ' ' + jQuery('#shipping_city_field').val() + ' ' + jQuery('#shipping_state_field').val() + ' ' + jQuery('#shipping_country_field').val() + ' ' + jQuery('#shipping_postcode').val()
        jQuery('.shipping_address_summary').html('<div class="shipping_address_name">' + shipping_name + '</div>' + '<div class="shipping_address_address">' + shipping_address + '</div>')
        if (jQuery('.shipping_method[value="free_shipping:9"]').length) {
            jQuery('.shipping_method[value="free_shipping:9"]').trigger('click')
        } else if (jQuery('.shipping_method[value="flat_rate:4"]').length) {
            jQuery('.shipping_method[value="flat_rate:4"]').trigger('click')
        } else if (jQuery('.shipping_method[value="flat_rate:6"]').length) {
            jQuery('.shipping_method[value="flat_rate:6"]').trigger('click')
        } 
        // else if (jQuery('.shipping_method[value="local_pickup:11"]').length) {
        //     jQuery('.shipping_method[value="local_pickup:11"]').trigger('click')
        // }
    } else if (ship_to_different_address == 'brt_fermopoint') {

        jQuery('.shipping_method[value="wc_brt_fermopoint_shipping_methods_custom:10"]').trigger('click')
        jQuery('#shipping_method_0_wc_brt_fermopoint_shipping_methods_custom10').trigger('click')
        // jQuery('.shipping_method_title').html('BRT FermoPoint');
        // jQuery('.shipping_address_summary').html('BRT FermoPoint');
        jQuery('.shipping_method').html('BRT FermoPoint');

    } else {
        jQuery('.shipping_method_title').html('Indirizzo di ritiro');
        var store_id = jQuery('input[name="store_id"]:checked').val();
        if (!store_id) {
            jQuery('#localshipping1').trigger('click')
        }
        var storeData = jQuery.parseJSON(jQuery('#store_data').val());

        jQuery('.shipping_address_summary').html('<div class="shipping_address_name">' + storeData[store_id].name + '</div>' + '<div class="shipping_address_address">' + storeData[store_id].address + '</div>' + '<div class="shipping_address_phone">' + storeData[store_id].phone_number + '</div>')
        jQuery('.shipping_method').html('Ritiro in negozio');
        jQuery('.shipping_method[value="local_pickup:11"]').trigger('click')
    }
    validateTerms()
}

function updateBillingSummary() {
    var paymentmethod = jQuery('input[name="payment_method"]:checked').val()
    if (paymentmethod == 'paypal') {
        paymentmethod = 'Paypal';
    }
    if (paymentmethod == 'stripe') {
        paymentmethod = 'Stripe';
    }
    if (paymentmethod == 'shoppayment') {
        paymentmethod = 'Pagamento in negozio';
    }
    if (paymentmethod == 'ppcp-gateway') {
        paymentmethod = 'Paypal';
    }
    if (paymentmethod == 'ppcp-credit-card-gateway') {
        paymentmethod = 'Carta di credito';
    }

    jQuery('.payment_method_selected').html(paymentmethod);
    var billing_name = jQuery('#billing_first_name').val() + ' ' + jQuery('#billing_last_name').val();
    var billing_address = jQuery('#billing_address_1').val() + ' ' + jQuery('#billing_address_2').val() + ' ' + jQuery('#billing_city').val() + ' ' + jQuery('#billing_state').val() + ' ' + jQuery('#billing_country').val() + ' ' + jQuery('#shipping_postcode').val()
    var billing_address_contact = jQuery('#billing_phone').val() + ' ' + jQuery('#billing_email').val();
    jQuery('.billing_address_summary').html('<div class="billing_address_name">' + billing_name + '</div>' + '<div class="billing_address_address">' + billing_address + '</div>' + '<div class="billing_address_contact">' + billing_address_contact + '</div>')
    validateTerms()
}


jQuery(document).on('change', '#override_details_with_shipping', function () {
    if (jQuery(this).is(":checked")) {
        jQuery('#billing_first_name').val(jQuery('#shipping_first_name').val())
        jQuery('#billing_last_name').val(jQuery('#shipping_last_name').val())
        jQuery('#billing_country').val(jQuery('#shipping_country').val())
        jQuery('#billing_city').val(jQuery('#shipping_city').val())
        jQuery('#billing_address_2').val(jQuery('#shipping_address_2').val())
        jQuery('#billing_address_1').val(jQuery('#shipping_address_1').val())
        jQuery('#billing_state').val(jQuery('#shipping_state').val())
        jQuery('#billing_postcode').val(jQuery('#shipping_postcode').val())
        jQuery('#billing_company').val(jQuery('#shipping_company').val())


    }
});

var menu_new;
if (document.querySelector('#mobile-menu-target')) {
    document.addEventListener("DOMContentLoaded", function () {
        menu_new = new SlideMenu(document.getElementById('mobile-menu-target'), {
            showBackLink: true,
            submenuLinkAfter: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 4.7 8' style='enable-background:new 0 0 4.7 8;' xml:space='preserve'><g><path d='M0.7,0.2c-0.1-0.1-0.2-0.1-0.3,0c-0.1,0.1-0.1,0.2,0,0.3L3.9,4L0.4,7.5c-0.1,0.1-0.1,0.2,0,0.3c0.1,0.1,0.2,0.1,0.3,0 l3.6-3.6l0,0c0.1-0.1,0.1-0.2,0-0.3l0,0C4.3,3.8,0.7,0.2,0.7,0.2z'/></g> <rect x='-2.7' y='-1.1' class='st0' width='10.1' height='10.1'/></svg>",
            position: 'left'
        });
    });
}

jQuery(document).on('click', 'input[name="terms"]', function () {
    if (jQuery(this).is(':checked')) {
        if (jQuery('.section-shipping').hasClass('filled') && jQuery('.section-billing-payment').hasClass('filled')) {
            jQuery('#place_order').attr('disabled', false)
        } else {
            jQuery('#place_order').attr('disabled', true)
        }
        jQuery('.section-terms-condition').removeClass('open').removeClass('not-filled')
        jQuery('.section-terms-condition').addClass('closed').addClass('filled')
        jQuery('.step-3').removeClass('mobile-open').removeClass('mobile-not-filled')
        jQuery('.step-3').addClass('mobile-closed').addClass('mobile-filled')
    } else {
        jQuery('#place_order').attr('disabled', true)
    }
    validateTerms()
})

jQuery(document).on('change', '#billing_cf,#billing_pa_code,#billing_invoice_type,#billing_piva', function () {
    validateBilling()
})

function validateBilling() {
    var isvalidated = true;
    jQuery('.woocommerce-billing-fields .validate-required input,.woocommerce-billing-fields .validate-required select').each(function () {
        if (jQuery(this).val() == '') {
            isvalidated = false;
        }
    })

    // var invoice_type = jQuery('#billing_invoice_type').val()
    // if('receipt'==invoice_type){
    //     if(jQuery('#billing_cf').val()==''){
    //         isvalidated = false;    
    //     }
    // }
    // var invoice_type = jQuery('#billing_invoice_type').val()
    // if('receipt'==invoice_type){
    //     if(jQuery('#billing_cf').val()==''){
    //         isvalidated = false;    
    //     }
    // }
    // if('invoice'==invoice_type){
    //     if(jQuery('#billing_piva').val()==''){
    //         isvalidated = false;    
    //     }
    //     // if(jQuery('#billing_pec').val()==''){
    //     //     isvalidated = false;    
    //     // }
    //     if(jQuery('#billing_pa_code').val()==''){
    //         isvalidated = false;    
    //     }

    // }
    // // if('private_invoice'==invoice_type){
    // //     if(jQuery('#billing_pec').val()==''){
    // //         isvalidated = false;    
    // //     }
    // // }
    // if('professionist_invoice'==invoice_type){
    //     if(jQuery('#billing_piva').val()==''){
    //         isvalidated = false;    
    //     }
    //     if(jQuery('#billing_cf').val()==''){
    //         isvalidated = false;    
    //     }
    //     // if(jQuery('#billing_pec').val()==''){
    //     //     isvalidated = false;    
    //     // }
    //     if(jQuery('#billing_pa_code').val()==''){
    //         isvalidated = false;    
    //     }
    // }

    if (isvalidated) {
        jQuery('.confirm_billing').attr('disabled', false)
    } else {
        jQuery('.confirm_billing').attr('disabled', true)
    }
}
jQuery(document).on('change', '.woocommerce-billing-fields .validate-required input,.woocommerce-billing-fields .validate-required select', function () {
    validateBilling()
})
function validateShipping() {
    var isvalidated = true;
    jQuery('.shipping_address .validate-required input,.shipping_address .validate-required select').each(function () {
        if (jQuery(this).val() == '') {
            isvalidated = false;
        }
    })

    if (isvalidated) {
        jQuery('.confirm_shipping').attr('disabled', false)
    } else {
        jQuery('.confirm_shipping').attr('disabled', true)
    }
}
jQuery(document).on('change', '.shipping_address .validate-required input,.shipping_address .validate-required select', function () {
    validateShipping()
})

function validateTerms() {
    if (jQuery('input[name="terms"]').is(':checked')) {
        if (jQuery('.section-shipping').length) {
            if (jQuery('.section-shipping').hasClass('filled') && jQuery('.section-billing-payment').hasClass('filled')) {
                jQuery('#place_order').attr('disabled', false)
            } else {
                jQuery('#place_order').attr('disabled', true)
            }
        } else {
            if (jQuery('.section-billing-payment').hasClass('filled')) {
                jQuery('#place_order').attr('disabled', false)
            } else {
                jQuery('#place_order').attr('disabled', true)
            }
        }

    } else {
        jQuery('#place_order').attr('disabled', true)
    }
}

if (document.querySelector('#tabs') || 1 == 1) {
    (function ($) {
        /****************************/
        /* VARS DECLARATION *********/
        /****************************/
        var stores;
        var self = this;
        var map;
        var markers = [];
        var labels = [];
        var markers_clustering = null;
        var config = {
            clustering: true,
            debug: false
        };
        var query_params = {
            shop_type: getQueryParam('shop_type', null),
            search: getQueryParam('search', null),
            country_code: getCountryFromUrl(),
            lat: getQueryParam('lat', null),
            lng: getQueryParam('lng', null),
            zoom: getQueryParam('zoom', null),
        };
        var filtered_stores = [];
        var rebuild_map_timeout;
        var country_code_timeout;
        var bounds_changed_timeout;
        var geocoder;

        /****************************/
        /* DOCUMENT READY ***********/
        /****************************/
        $(document).ready(function () {

            if (!$('#archive-wooden-stores').length && !jQuery('#single-wooden-stores').length) {
                return;
            }
            stores = getStoresListFromDOM();
            initMap();
            drawMarkers();
            autoComplete();
            useMyPosition();
            // filtersHandler();
            // applyFilters();
            handleStoresList();
            filterStoresList([], stores);
            setCountryCodeFromPosition();
            //sortStoresByDistance();
            // navigationHistory();
            // setOpeningHours();
        });


        /****************************/
        /* WINDOW SCROLL ************/
        /****************************/
        $(window).scroll(function () {
        });

        /****************************/
        /* GET STORES ***************/
        /****************************/
        var getStoresListFromDOM = function () {
            var $stores_list = $('.stores-list');
            var $stores = $stores_list.find('.store');
            var stores = [];
            $stores.each(function () {
                var $store = $(this);
                stores.push({
                    id: $store.attr("data-store-id"),
                    lat: $store.attr("data-store-lat"),
                    lng: $store.attr("data-store-lng"),
                    title: 'Wooden Store\n' + $store.attr("data-store-title"),
                    permalink: $store.attr("data-store-permalink"),
                });
            });
            return stores;
        };

        /****************************/
        /* MAP HANDLERS *************/
        /****************************/
        function initMap() {
            var $ = jQuery.noConflict();
            var map_data = {
                lat: $('#gmap').attr('data-store-lat') ? $('#gmap').attr('data-store-lat') : 41.8719,
                lng: $('#gmap').attr('data-store-lng') ? $('#gmap').attr('data-store-lng') : 12.5674,
                zoom: $('#gmap').data('zoom') ? $('#gmap').data('zoom') : 6
            };

            if ($('#gmap').length) {
                map = new google.maps.Map(document.getElementById('gmap'), {
                    zoom: map_data.zoom,
                    center: {
                        lat: parseFloat(map_data.lat),
                        lng: parseFloat(map_data.lng)
                    },
                    disableDefaultUI: true,
                    zoomControl: true,
                    zoomControlOptions: {
                        position: google.maps.ControlPosition.LEFT_BOTTOM
                    },
                    scrollwheel: false,
                    styles: getMapDarkStyle()
                });

                /* $.get('https://restcountries.eu/rest/v2/alpha/it/', function(response) {
                      if (response && !response.status) {
                          var lat = response.latlng[0];
                          var lng = response.latlng[1];
                          map.panTo(new google.maps.LatLng(lat, lng));
                          map.setZoom(7);
                      } else {
                          map.panTo(new google.maps.LatLng(0, 0));
                          map.setZoom(7);
                      }
                  })
                  .fail(function() {
                    // map.panTo(new google.maps.LatLng(0, 0));
                    // map.setZoom(3);
                  }); */
            };


            geocoder = new google.maps.Geocoder();
        };

        function initStoreLocator() {
            var map_options = {
                zoom: query_params.zoom ? Number(query_params.zoom) : 8,
                center: new google.maps.LatLng(query_params.lat, query_params.lng),
                mapTypeControl: false,
                streetViewControl: false,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                scrollwheel: false
            };
            map = new google.maps.Map(
                document.getElementById("gmap"),
                map_options
            );
            geocoder = new google.maps.Geocoder();

            // SHOW THE WORLD BEFORE EXECUTING THE REST OF THE LOGIC
            map.panTo(new google.maps.LatLng(0, 0));
            map.setZoom(3);

            var translated_url = translateURL();

            if (translated_url) {
                // USE STORE URL KEY
                map.panTo(new google.maps.LatLng(Number(translated_url.lat), Number(translated_url.lng)));
                map.setZoom(24);
            } else if (query_params.search || (query_params.lat && query_params.lng && query_params.zoom)) {
                // IF THERE ARE QUERY PARAMS, USE THEM
                if (query_params.lat && query_params.lng) {
                    map.panTo(new google.maps.LatLng(Number(query_params.lat), Number(query_params.lng)));
                } else if (query_params.search) {
                    geocoder.geocode({ 'address': query_params.search }, function (results, status) {
                        if (results.length) {
                            map.fitBounds(bounds);
                        }
                    });
                }
            } else if (navigator.geolocation) {
                // PARSE URL AND MOVE TO CURRENT REGION
                $.get('https://restcountries.eu/rest/v2/alpha/' + query_params.country_code, function (response) {
                    if (response && !response.status) {
                        var lat = response.latlng[0];
                        var lng = response.latlng[1];
                        map.panTo(new google.maps.LatLng(lat, lng));
                        map.setZoom(6);
                    } else {
                        map.panTo(new google.maps.LatLng(0, 0));
                        map.setZoom(3);
                    }
                })
                    .fail(function () {
                        map.panTo(new google.maps.LatLng(0, 0));
                        map.setZoom(3);
                    });

                // IF USER ALLOWS GELOCATION, USE IT
                navigator.geolocation.getCurrentPosition(function (position) {
                    map.panTo(new google.maps.LatLng(position.coords.latitude, position.coords.longitude));
                    map.setZoom(10);
                }, function (error) {
                    // TRY TO GEOLOCATE BY USER LANGUAGE CHOICE
                    geocoder.geocode({ 'address': query_params.country_code }, function (results, status) {
                        if (results.length) {
                            $.get('https://restcountries.eu/rest/v2/alpha/' + query_params.country_code, function (response) {
                                if (response && !response.status) {
                                    var lat = response.latlng[0];
                                    var lng = response.latlng[1];
                                    map.panTo(new google.maps.LatLng(lat, lng));
                                    map.setZoom(6);
                                } else {
                                    map.panTo(new google.maps.LatLng(0, 0));
                                    map.setZoom(3);
                                }
                            })
                                .fail(function () {
                                    map.panTo(new google.maps.LatLng(0, 0));
                                    map.setZoom(3);
                                });
                        }
                    });
                });
            } else {
                $.get('https://restcountries.eu/rest/v2/alpha/' + query_params.country_code, function (response) {
                    if (response && !response.status) {
                        var lat = response.latlng[0];
                        var lng = response.latlng[1];
                        map.panTo(new google.maps.LatLng(lat, lng));
                        map.setZoom(6);
                    } else {
                        map.panTo(new google.maps.LatLng(0, 0));
                        map.setZoom(3);
                    }
                })
                    .fail(function () {
                        map.panTo(new google.maps.LatLng(0, 0));
                        map.setZoom(3);
                    });
            }
            google.maps.event.addListener(map, 'idle', function () {
                $('#ds-map.hidden').removeClass('hidden');
            });
        };

        function setCountryCodeFromPosition() {
            // ON BOUNDS CHANGED
            google.maps.event.addListener(map, 'bounds_changed', function () {
                clearTimeout(country_code_timeout);
                country_code_timeout = setTimeout(function () {

                    var latlng = new google.maps.LatLng(map.getCenter().lat(), map.getCenter().lng());
                    geocoder.geocode({ 'location': latlng }, function (results, status) {
                        if (status === 'OK' && results[0]) {
                            var location = results[0];
                            location.address_components.forEach(function (ac) {
                                if (ac.types.indexOf('country') >= 0) {
                                    query_params.country_code = ac.short_name;
                                    query_params.place_id = ac.short_name;
                                    // $('.geolocate.city-autocomplete').val(ac.long_name);
                                    return;
                                }
                            });
                        }
                    });
                }, 50);
            });
        };

        function drawMarkers() {
            // ON BOUNDS CHANGED
            google.maps.event.addListener(map, 'bounds_changed', function () {
                clearTimeout(rebuild_map_timeout);
                rebuild_map_timeout = setTimeout(function () {
                    sortStoresByDistance();
                    var marker_index = 0;
                    var filtered_stores = [];
                    var remaining_stores = [];
                    // UNSET MARKERS AND MARKER CLUSTERS
                    while (markers.length) {
                        markers.pop().setMap(null);
                    }
                    if (markers_clustering) {
                        markers_clustering.clearMarkers();
                        markers_clustering = null;
                    }
                    // SET MARKERS AND MARKER CLUSTERS
                    stores.forEach(function (store, i) {
                        if (map.getZoom() > 5 && !isMobile()) {

                            if (!map.getBounds()) { return; }
                            if (map.getBounds().contains(new google.maps.LatLng(Number(store.lat), Number(store.lng))) /*&& store.country.toLowerCase() === query_params.country_code.toLowerCase()*/) {
                                var marker = new google.maps.Marker({
                                    position: {
                                        lat: Number(store.lat),
                                        lng: Number(store.lng)
                                    },
                                    title: store.title,
                                    icon: my_ajax_object.theme_url + '/assets/img/gmap/pin.png',
                                    origid: store.id,
                                    id: store.id,
                                    label: {
                                        text: getMarkerLabel(marker_index),
                                        color: '#FFFFFF'
                                    }
                                });
                                setMarkerEvents(marker);
                                markers.push(marker);
                                filtered_stores.push(store);
                                marker_index++;
                            } else {
                                remaining_stores.push(store);
                            }
                        } else {
                            if (map.getBounds().contains(new google.maps.LatLng(Number(store.lat), Number(store.lng)))) {
                                var marker = new google.maps.Marker({
                                    position: {
                                        lat: Number(store.lat),
                                        lng: Number(store.lng)
                                    },
                                    title: store.title,
                                    icon: my_ajax_object.theme_url + '/assets/img/gmap/pin.png',
                                    origid: store.id,
                                    id: store.id,
                                    label: {
                                        text: getMarkerLabel(marker_index),
                                        color: '#FFFFFF'
                                    }
                                });
                                setMarkerEvents(marker);
                                markers.push(marker);
                                filtered_stores.push(store);
                                marker_index++;
                            } else {
                                remaining_stores.push(store);
                            }
                        }
                    });
                    filterStoresList(filtered_stores, remaining_stores);
                    markers_clustering = new MarkerClusterer(map, markers, {
                        imagePath: my_ajax_object.theme_url + '/assets/img/gmap/cluster/',
                        styles: [
                            {
                                url: my_ajax_object.theme_url + '/assets/img/gmap/cluster/1.png',
                                width: 32,
                                height: 32
                            },
                            {
                                url: my_ajax_object.theme_url + '/assets/img/gmap/cluster/2.png',
                                width: 32,
                                height: 32
                            },
                            {
                                url: my_ajax_object.theme_url + '/assets/img/gmap/cluster/3.png',
                                width: 32,
                                height: 32
                            },
                        ]
                    });

                    // UPDATE RESULTS
                    $('.stores-count').text(markers.length);
                }, 500);
            });
        };

        function translateURL() {
            var $ = jQuery.noConflict();
            var urlKey = window.location.pathname.replace(/\/$/, "").split('/');
            urlKey = urlKey[urlKey.length - 1];
            if (query_params.search || (query_params.lat && query_params.lng && query_params.zoom)) {
                return false;
            }
            if (urlKey.toLowerCase() !== 'storelocator') {
                var $store = $("li[data-url*='" + urlKey + "']");
                var lat = $store.attr('data-lat');
                var lng = $store.attr('data-lng');
                return {
                    lat: lat,
                    lng: lng
                }
            }
            return false;
        };

        function navigationHistory() {
            return;
            var $ = jQuery.noConflict();
            if (history.pushState) {
                google.maps.event.addListener(map, 'bounds_changed', function () {
                    clearTimeout(bounds_changed_timeout);
                    bounds_changed_timeout = setTimeout(function () {
                        var prev_url = window.location.href ? window.location.href : "";
                        var base_url = window.location.href.replace(window.location.search, '');
                        var query = window.location.search.replace('?', '');
                        var shop_query = $('.filter-aplly-button').attr('data-filter-param');
                        var lat = map.getCenter().lat();
                        var lng = map.getCenter().lng();
                        var zoom = map.getZoom();
                        var url_to_push = "";
                        if ($('.ds-list li:visible').length >= 1 && $('.ds-list li:visible').length === 1) {
                            if (shop_query) {
                                url_to_push = $('.ds-list li:visible').first().attr('data-url') + '/' + shop_query;
                            } else {
                                url_to_push = $('.ds-list li:visible').first().attr('data-url') + '/';
                            }
                            $('link[rel=canonical]').attr('href', $('.ds-list li:visible').attr('data-url') + '/');
                        } else if (shop_query) {
                            base_url = base_url.substring(0, base_url.indexOf('storelocator') + 'storelocator'.length + 1);
                            url_to_push = (base_url + shop_query + "&lat=" + lat + "&lng=" + lng + "&zoom=" + zoom);
                            $('link[rel=canonical]').attr('href', base_url);
                        } else {
                            base_url = base_url.substring(0, base_url.indexOf('storelocator') + 'storelocator'.length + 1);
                            url_to_push = (base_url + "?lat=" + lat + "&lng=" + lng + "&zoom=" + zoom);
                            $('link[rel=canonical]').attr('href', base_url);
                        }
                        if (prev_url !== url_to_push) {
                            history.pushState({ prev_url: prev_url, next_url: url_to_push }, "LiuJo - Store Locator", url_to_push);
                        }
                    }, 1000);
                });

            }
        };

        // WINDOW HISTORY POP STATE
        window.addEventListener("popstate", function (e) {
            if (window.location.href === e.state.prev_url) {
                window.location.replace(e.state.prev_url);
            } else {
                window.location.replace(e.state.next_url);
            }
        });

        function setMarkerEvents(marker) {
            google.maps.event.addListener(marker, 'click', function (event) {
                jQuery('.store').removeClass('active');
                var $target_store = $('#store-' + marker.origid);
                $target_store.addClass('active');
                if ($target_store.length) {
                    map.panTo(new google.maps.LatLng(marker.getPosition().lat(), marker.getPosition().lng()));
                }
            });
            google.maps.event.addListener(marker, 'mouseover', function (event) {
                // this.setIcon("/skin/frontend/enterprise/liujo2017/images/alpenrestyling/svg/lj-black-circle-big.png");
            });
            google.maps.event.addListener(marker, 'mouseout', function (event) {
                // this.setIcon("/skin/frontend/enterprise/liujo2017/images/alpenrestyling/svg/lj-black-circle.png");
            });
        };

        function autoComplete() {
            var cities = $('.store-finder .store-finder-input');
            if (!cities.length) {
                return;
            }
            cities.each(function (i, city) {
                $(city).on('input', function () {
                    if (!$(this).val().length) {
                        if ($(this).siblings('.city-latitude').length) {
                            $(this).siblings('.city-latitude').val('');
                        }
                        if ($(this).siblings('.city-longitude').length) {
                            $(this).siblings('.city-longitude').val('');
                        }
                    }
                });
                var autocomplete = new google.maps.places.Autocomplete(city, {
                    types: ['geocode']
                });
                var countrySelector = null;
                if ($(city).data('country')) {
                    countrySelector = $(city).data('country');
                }
                autocomplete.addListener('place_changed', function () {
                    // map.panTo(new google.maps.LatLng(autocomplete.getPlace().geometry.location.lat(), autocomplete.getPlace().geometry.location.lng()));
                    if (autocomplete && autocomplete.getPlace() && autocomplete.getPlace().geometry) {
                        map.fitBounds(autocomplete.getPlace().geometry.viewport);
                    }
                });
            });
            var search_box = new google.maps.places.SearchBox($('.store-finder').get(0));
            google.maps.event.addListener(search_box, 'places_changed', function () {
                var place = search_box.getPlaces()[0];
                if (!place.geometry) return;
                if (place.geometry.viewport) {
                    map.fitBounds(place.geometry.viewport);
                } else {
                    map.setCenter(place.geometry.location);
                    map.setZoom(17);
                }
            });
            google.maps.event.addListener(map, 'bounds_changed', function () {
                var bounds = map.getBounds();
                search_box.setBounds(bounds);
            });
        };

        function useMyPosition() {
            $('.use-my-position').click(function () {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function (position) {
                        map.panTo(new google.maps.LatLng(position.coords.latitude, position.coords.longitude));
                        map.setZoom(10);
                    }, function () {

                    });
                }
            });
        };

        function filtersHandler() {
            var $filters_opener = $('.filter-opener');
            var $filters_container = $('.filter-values');
            var $filters_background = $('.filter-background');
            var $filters = $('#lj-storelocator-filter-container .filter-values ol li a');
            var $submit_button = $('.filter-aplly-button');

            $filters_opener.click(function () {
                if ($filters_container.is(':visible')) {
                    $filters_container.slideUp();
                    $filters_background.fadeOut(500);
                } else {
                    $filters_container.slideDown();
                    $filters_background.fadeIn(500);
                }
            });
            $filters_background.click(function () {
                $filters_opener.click();
            });

            var update_filters = function () {
                var active_filters = [];
                $filters.each(function (i) {
                    var $filter = $(this);
                    if ($filter.hasClass('selected')) {
                        var param = $filter.data('base-url').substr($filter.data('base-url').indexOf('?') + 1);
                        active_filters.push(param.replace('shop_type=', ''));
                    }
                });
                var query = "";
                active_filters.forEach(function (filter, i) {
                    if (filter) {
                        if (i === 0) {
                            query += "?shop_type=" + filter
                        } else {
                            query += "," + filter;
                        }
                    }
                });
                $submit_button.attr('data-filter-param', query);
            };

            update_filters();

            $filters.each(function () {
                var $filter = $(this);
                $filter.click(function (e) {
                    e.preventDefault();
                    $filter.toggleClass('selected');
                    update_filters();
                });
            });
        };

        function applyFilters() {
            var $apply_button = $('#lj-storelocator-filter-container .filter-aplly-button');
            var base_url = window.location.href.replace(window.location.search, '');

            $apply_button.click(function () {
                var filter_params = $apply_button.attr('data-filter-param');
                var lat = map.getCenter().lat();
                var lng = map.getCenter().lng();
                var zoom = map.getZoom();
                var geolocation_params = "&lat=" + lat + "&lng=" + lng + "&zoom=" + zoom;
                if (filter_params) {
                    window.location = base_url + filter_params + geolocation_params;
                } else {
                    window.location = base_url + geolocation_params.replace('&', '?');
                }
            });
        };

        /****************************/
        /* UTILITIES ****************/
        /****************************/

        function setOpeningHours() {
            var date = new Date();
            var timezone = date.getTimezoneOffset();
            var now = Math.floor(new Date().getTime() / 1000) - (timezone * 60);
            var half_an_hour = 30 * 60;
            $('.is-now-open').each(function () {
                var $is_now_open = $(this);
                var business_hours = $is_now_open.attr('data-store-business-hours');
                if (business_hours) {
                    business_hours = business_hours.split('|');
                    var hour_found = false;
                    business_hours.forEach(function (time, i) {
                        if (i % 2 == 0) {
                            var lower_time = Number(time);
                            var upper_time = Number(business_hours[i + 1]);
                            var human_upper_hours = (new Date((upper_time + (timezone * 60)) * 1000).getHours());
                            human_upper_hours = human_upper_hours < 10 ? "0" + human_upper_hours : human_upper_hours;
                            var human_upper_minutes = (new Date((upper_time + (timezone * 60)) * 1000).getMinutes());
                            human_upper_minutes = human_upper_minutes < 10 ? "0" + human_upper_minutes : human_upper_minutes;
                            var human_upper_time = human_upper_hours + ":" + human_upper_minutes;
                            // OPENING TIMES
                            if (now >= (lower_time - half_an_hour) && now < lower_time) {
                                $is_now_open.text(Translator.translate('Coming Soon'));
                                hour_found = true;
                            } else if (now >= lower_time && now < (upper_time - half_an_hour)) {
                                $is_now_open.text(Translator.translate('Open until') + " " + human_upper_time);
                                hour_found = true;
                            } else if (now >= (upper_time - half_an_hour) && now < upper_time) {
                                $is_now_open.text(Translator.translate('Open until') + " " + human_upper_time);
                                hour_found = true;
                            }
                        }
                    });
                    if (!hour_found) {
                        $is_now_open.text(Translator.translate('Now is close'));
                    }
                }
            });
        };

        function getCountryFromUrl() {
            return window.location.pathname.split('/')[1];
        };

        function getQueryParam(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        };

        function filterStoresList(filtered_stores, remaining_stores) {
            // SHOW STORES IN MAP
            filtered_stores.forEach(function (store, i) {
                var $store = $('#store-' + store.id);
                $store.remove().appendTo($('.stores-list'));
                $store.slideDown(0);
            });
            // HIDE REMAINING STORES
            remaining_stores.forEach(function (store) {
                var $store = $('#store-' + store.id);
                $store.slideUp(0);
            });
            navigationHistory();
            handleStoresList();
        };

        function handleStoresList() {
            var $stores_list = $('.stores-list');
            var $stores = $stores_list.find('.store');
            $stores.each(function () {
                var $store = $(this);
            });
            $('.ds-list .ds-item:visible').each(function (i) {
                var $store = $(this);
                var $open_details_button = $store.find('.store-details-separator');
                if ($open_details_button.length && typeof $._data($open_details_button.get(0), 'events') === 'undefined') {
                    // SHOW / HIDE DETAILS
                    $open_details_button.click(function (e) {
                        var $this = $(this);
                        var is_visible = $this.next().is(':visible');
                        $('.store-details-separator').next(':visible').slideToggle();
                        if (!is_visible) {
                            $this.next().slideToggle();
                        }
                    });
                }
                var $store_name = $store.find('.ds-name');
                if ($store_name.length && typeof $._data($store_name.get(0), 'events') === 'undefined') {
                    // FOLLOW LINK IF MOBILE
                    $store_name.click(function (e) {
                        if ($(window).width() <= 767) {
                            window.location = $store.data('link');
                        }
                    });
                }
                if (typeof $._data($store.get(0), 'events') === 'undefined') {
                    // FOLLOW LINK IF MOBILE
                    $store.click(function (e) {
                        if (!$(e.target).hasClass('clickandcollect')) {
                            map.panTo(new google.maps.LatLng(Number($store.attr('data-lat')), Number($store.attr('data-lng'))));
                            map.setZoom(20);
                            $('html, body').stop().animate({
                                'scrollTop': 0
                            });
                        } else {
                            var $popup = $('.popupClickAndCollect');
                            var $popup_bg = $('.popupClickAndCollectBackground');
                            if (!isMobile()) {
                                var $popup_bkg = $('.popupClickAndCollectBackground');
                                if ($popup_bkg.is(':visible')) {
                                    $popup.fadeOut();
                                    $popup_bg.fadeOut();
                                } else {
                                    $popup_bkg.fadeIn();
                                    $popup.fadeIn();
                                }
                            } else {
                                $('.click-and-collect-mobile').slideDown();
                            }
                            $('.popupClickAndCollectBackground, .closeClickAndCollect').click(function () {
                                $popup.fadeOut();
                                $popup_bg.fadeOut();
                            });
                        }
                    });
                }
                $store.hover(function () {
                    // TODO
                }, function () {
                    // TODO
                });
            });
        };

        function isStoreOpen(opening_time) {
            return false;
            opening_time = opening_time.replace(/^\,+|\,+$/g, '').split(',');
            var date = new Date();
            var today = date.getDay() - 1;
            if (opening_time[today]) {

                // normalizing string
                var _ott = opening_time[today].trim() // remove trailing spaces
                    .replace(/\s*-\s*/g, '-')   // remove additionals spaces before and after the minus sign
                    .replace(/\s+/g, ' ');      // remove consecutive spaces

                // check for double range string
                var _ottRanges = [];
                if (_ott.indexOf(' ') != -1) {
                    _ottRanges = _ott.split(' ');
                } else {
                    _ottRanges.push(_ott);
                }

                var _returnValue = false;
                $.each(_ottRanges, function (_idx, today_hour) {
                    today_hour = today_hour.split('-');
                    if (typeof today_hour !== 'undefined' && today_hour.length > 0 && today_hour[0] !== ' ' && today_hour[0] !== '') {
                        var from = _toSeconds(today_hour[0].trim() + ':00');
                        var to = today_hour[1] ? _toSeconds(today_hour[1].trim() + ':00') : '';
                        var now = _toSeconds(date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds());
                        if (!_returnValue && now >= from && now <= to) {
                            _returnValue = today_hour[1].trim();
                        }
                    }
                });
                return _returnValue;
            }
            return false;
        };

        function sortStoresByDistance() {
            var unit = "K";
            var center = {
                lat: map.getCenter().lat(),
                lng: map.getCenter().lng()
            };
            // SET DISTANCE FROM CENTER FOR ALL STORES
            stores.forEach(function (store, i) {
                if (store.lat == center.lat && store.lng == center.lng) {
                    return 0;
                }
                var radlat1 = Math.PI * store.lat / 180;
                var radlat2 = Math.PI * center.lat / 180;
                var radtheta = Math.PI * (store.lng - center.lng) / 180;
                var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                dist = Math.acos(dist);
                dist = dist * 180 / Math.PI;
                dist = dist * 60 * 1.1515;
                if (unit == "K") {
                    dist = dist * 1.609344;
                }
                else if (unit == "N") {
                    dist = dist * 0.8684;
                }
                stores[i].dist = dist;
            });
            // SORT BY DISTANCE
            stores.sort(function (s1, s2) {
                return s1.dist > s2.dist ? 1 : (s1.dist < s2.dist ? -1 : 0);
            });
        };

        function getMarkerLabel(i) {
            var alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
            var heading_letters = "";
            for (var j = 0; j < Math.floor(i / alphabet.length); j++) {
                heading_letters = alphabet[j] ? alphabet[j] : "";
            }
            return heading_letters + alphabet[i % alphabet.length];
        };

        var getMapDarkStyle = function () {
            return [
                {
                    "featureType": "all",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "all",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        },
                        {
                            "saturation": "-100"
                        }
                    ]
                },
                {
                    "featureType": "all",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "saturation": 36
                        },
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 40
                        },
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "all",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "visibility": "off"
                        },
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 16
                        }
                    ]
                },
                {
                    "featureType": "all",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 20
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 17
                        },
                        {
                            "weight": 1.2
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 20
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#4d6059"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#4d6059"
                        }
                    ]
                },
                {
                    "featureType": "landscape.natural",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#4d6059"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "lightness": 21
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#4d6059"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#4d6059"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#7f8d89"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#7f8d89"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#7f8d89"
                        },
                        {
                            "lightness": 17
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#7f8d89"
                        },
                        {
                            "lightness": 29
                        },
                        {
                            "weight": 0.2
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 18
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#7f8d89"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#7f8d89"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 16
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#7f8d89"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#7f8d89"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 19
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#2b3638"
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#2b3638"
                        },
                        {
                            "lightness": 17
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#24282b"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#24282b"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                }
            ];
        };

        var getMapLightStyle = function () {
            return [
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#e9e9e9"
                        },
                        {
                            "lightness": 17
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        },
                        {
                            "lightness": 20
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 17
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 29
                        },
                        {
                            "weight": 0.2
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 18
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 16
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        },
                        {
                            "lightness": 21
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#dedede"
                        },
                        {
                            "lightness": 21
                        }
                    ]
                },
                {
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 16
                        }
                    ]
                },
                {
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "saturation": 36
                        },
                        {
                            "color": "#333333"
                        },
                        {
                            "lightness": 40
                        }
                    ]
                },
                {
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f2f2f2"
                        },
                        {
                            "lightness": 19
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#fefefe"
                        },
                        {
                            "lightness": 20
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#fefefe"
                        },
                        {
                            "lightness": 17
                        },
                        {
                            "weight": 1.2
                        }
                    ]
                }
            ];
        };
    })(jQuery.noConflict());
}

function isMobile() {
    return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
}


// ==ClosureCompiler==
// @compilation_level ADVANCED_OPTIMIZATIONS
// @externs_url https://raw.githubusercontent.com/google/closure-compiler/master/contrib/externs/maps/google_maps_api_v3.js
// ==/ClosureCompiler==

/**
 * @name MarkerClusterer for Google Maps v3
 * @version version 1.0
 * @author Luke Mahe
 * @fileoverview
 * The library creates and manages per-zoom-level clusters for large amounts of
 * markers.
 * <br/>
 * This is a v3 implementation of the
 * <a href="http://gmaps-utility-library-dev.googlecode.com/svn/tags/markerclusterer/"
 * >v2 MarkerClusterer</a>.
 */

/**
 * @license
 * Copyright 2010 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * A Marker Clusterer that clusters markers.
 *
 * @param {google.maps.Map} map The Google map to attach to.
 * @param {Array.<google.maps.Marker>=} opt_markers Optional markers to add to
 *   the cluster.
 * @param {Object=} opt_options support the following options:
 *     'gridSize': (number) The grid size of a cluster in pixels.
 *     'maxZoom': (number) The maximum zoom level that a marker can be part of a
 *                cluster.
 *     'zoomOnClick': (boolean) Whether the default behaviour of clicking on a
 *                    cluster is to zoom into it.
 *     'averageCenter': (boolean) Whether the center of each cluster should be
 *                      the average of all markers in the cluster.
 *     'minimumClusterSize': (number) The minimum number of markers to be in a
 *                           cluster before the markers are hidden and a count
 *                           is shown.
 *     'styles': (object) An object that has style properties:
 *       'url': (string) The image url.
 *       'height': (number) The image height.
 *       'width': (number) The image width.
 *       'anchor': (Array) The anchor position of the label text.
 *       'textColor': (string) The text color.
 *       'textSize': (number) The text size.
 *       'backgroundPosition': (string) The position of the backgound x, y.
 *       'iconAnchor': (Array) The anchor position of the icon x, y.
 * @constructor
 * @extends google.maps.OverlayView
 */
function MarkerClusterer(map, opt_markers, opt_options) {
    // MarkerClusterer implements google.maps.OverlayView interface. We use the
    // extend function to extend MarkerClusterer with google.maps.OverlayView
    // because it might not always be available when the code is defined so we
    // look for it at the last possible moment. If it doesn't exist now then
    // there is no point going ahead :)
    this.extend(MarkerClusterer, google.maps.OverlayView);
    this.map_ = map;

    /**
     * @type {Array.<google.maps.Marker>}
     * @private
     */
    this.markers_ = [];

    /**
     *  @type {Array.<Cluster>}
     */
    this.clusters_ = [];

    this.sizes = [53, 56, 66, 78, 90];

    /**
     * @private
     */
    this.styles_ = [];

    /**
     * @type {boolean}
     * @private
     */
    this.ready_ = false;

    var options = opt_options || {};

    /**
     * @type {number}
     * @private
     */
    this.gridSize_ = options['gridSize'] || 60;

    /**
     * @private
     */
    this.minClusterSize_ = options['minimumClusterSize'] || 2;


    /**
     * @type {?number}
     * @private
     */
    this.maxZoom_ = options['maxZoom'] || null;

    this.styles_ = options['styles'] || [];

    /**
     * @type {string}
     * @private
     */
    this.imagePath_ = options['imagePath'] ||
        this.MARKER_CLUSTER_IMAGE_PATH_;

    /**
     * @type {string}
     * @private
     */
    this.imageExtension_ = options['imageExtension'] ||
        this.MARKER_CLUSTER_IMAGE_EXTENSION_;

    /**
     * @type {boolean}
     * @private
     */
    this.zoomOnClick_ = true;

    if (options['zoomOnClick'] != undefined) {
        this.zoomOnClick_ = options['zoomOnClick'];
    }

    /**
     * @type {boolean}
     * @private
     */
    this.averageCenter_ = false;

    if (options['averageCenter'] != undefined) {
        this.averageCenter_ = options['averageCenter'];
    }

    this.setupStyles_();

    this.setMap(map);

    /**
     * @type {number}
     * @private
     */
    this.prevZoom_ = this.map_.getZoom();

    // Add the map event listeners
    var that = this;
    google.maps.event.addListener(this.map_, 'zoom_changed', function () {
        var zoom = that.map_.getZoom();

        if (that.prevZoom_ != zoom) {
            that.prevZoom_ = zoom;
            that.resetViewport();
        }
    });

    google.maps.event.addListener(this.map_, 'idle', function () {
        that.redraw();
    });

    // Finally, add the markers
    if (opt_markers && opt_markers.length) {
        this.addMarkers(opt_markers, false);
    }
}


/**
 * The marker cluster image path.
 *
 * @type {string}
 * @private
 */
MarkerClusterer.prototype.MARKER_CLUSTER_IMAGE_PATH_ = '../images/m';


/**
 * The marker cluster image path.
 *
 * @type {string}
 * @private
 */
MarkerClusterer.prototype.MARKER_CLUSTER_IMAGE_EXTENSION_ = 'png';


/**
 * Extends a objects prototype by anothers.
 *
 * @param {Object} obj1 The object to be extended.
 * @param {Object} obj2 The object to extend with.
 * @return {Object} The new extended object.
 * @ignore
 */
MarkerClusterer.prototype.extend = function (obj1, obj2) {
    return (function (object) {
        for (var property in object.prototype) {
            this.prototype[property] = object.prototype[property];
        }
        return this;
    }).apply(obj1, [obj2]);
};


/**
 * Implementaion of the interface method.
 * @ignore
 */
MarkerClusterer.prototype.onAdd = function () {
    this.setReady_(true);
};

/**
 * Implementaion of the interface method.
 * @ignore
 */
MarkerClusterer.prototype.draw = function () { };

/**
 * Sets up the styles object.
 *
 * @private
 */
MarkerClusterer.prototype.setupStyles_ = function () {
    if (this.styles_.length) {
        return;
    }

    for (var i = 0, size; size = this.sizes[i]; i++) {
        this.styles_.push({
            url: this.imagePath_ + (i + 1) + '.' + this.imageExtension_,
            height: size,
            width: size
        });
    }
};

/**
 *  Fit the map to the bounds of the markers in the clusterer.
 */
MarkerClusterer.prototype.fitMapToMarkers = function () {
    var markers = this.getMarkers();
    var bounds = new google.maps.LatLngBounds();
    for (var i = 0, marker; marker = markers[i]; i++) {
        bounds.extend(marker.getPosition());
    }

    this.map_.fitBounds(bounds);
};


/**
 *  Sets the styles.
 *
 *  @param {Object} styles The style to set.
 */
MarkerClusterer.prototype.setStyles = function (styles) {
    this.styles_ = styles;
};


/**
 *  Gets the styles.
 *
 *  @return {Object} The styles object.
 */
MarkerClusterer.prototype.getStyles = function () {
    return this.styles_;
};


/**
 * Whether zoom on click is set.
 *
 * @return {boolean} True if zoomOnClick_ is set.
 */
MarkerClusterer.prototype.isZoomOnClick = function () {
    return this.zoomOnClick_;
};

/**
 * Whether average center is set.
 *
 * @return {boolean} True if averageCenter_ is set.
 */
MarkerClusterer.prototype.isAverageCenter = function () {
    return this.averageCenter_;
};


/**
 *  Returns the array of markers in the clusterer.
 *
 *  @return {Array.<google.maps.Marker>} The markers.
 */
MarkerClusterer.prototype.getMarkers = function () {
    return this.markers_;
};


/**
 *  Returns the number of markers in the clusterer
 *
 *  @return {Number} The number of markers.
 */
MarkerClusterer.prototype.getTotalMarkers = function () {
    return this.markers_.length;
};


/**
 *  Sets the max zoom for the clusterer.
 *
 *  @param {number} maxZoom The max zoom level.
 */
MarkerClusterer.prototype.setMaxZoom = function (maxZoom) {
    this.maxZoom_ = maxZoom;
};


/**
 *  Gets the max zoom for the clusterer.
 *
 *  @return {number} The max zoom level.
 */
MarkerClusterer.prototype.getMaxZoom = function () {
    return this.maxZoom_;
};


/**
 *  The function for calculating the cluster icon image.
 *
 *  @param {Array.<google.maps.Marker>} markers The markers in the clusterer.
 *  @param {number} numStyles The number of styles available.
 *  @return {Object} A object properties: 'text' (string) and 'index' (number).
 *  @private
 */
MarkerClusterer.prototype.calculator_ = function (markers, numStyles) {
    var index = 0;
    var count = markers.length;
    var dv = count;
    while (dv !== 0) {
        dv = parseInt(dv / 10, 10);
        index++;
    }

    index = Math.min(index, numStyles);
    return {
        text: count,
        index: index
    };
};


/**
 * Set the calculator function.
 *
 * @param {function(Array, number)} calculator The function to set as the
 *     calculator. The function should return a object properties:
 *     'text' (string) and 'index' (number).
 *
 */
MarkerClusterer.prototype.setCalculator = function (calculator) {
    this.calculator_ = calculator;
};


/**
 * Get the calculator function.
 *
 * @return {function(Array, number)} the calculator function.
 */
MarkerClusterer.prototype.getCalculator = function () {
    return this.calculator_;
};


/**
 * Add an array of markers to the clusterer.
 *
 * @param {Array.<google.maps.Marker>} markers The markers to add.
 * @param {boolean=} opt_nodraw Whether to redraw the clusters.
 */
MarkerClusterer.prototype.addMarkers = function (markers, opt_nodraw) {
    for (var i = 0, marker; marker = markers[i]; i++) {
        this.pushMarkerTo_(marker);
    }
    if (!opt_nodraw) {
        this.redraw();
    }
};


/**
 * Pushes a marker to the clusterer.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @private
 */
MarkerClusterer.prototype.pushMarkerTo_ = function (marker) {
    marker.isAdded = false;
    if (marker['draggable']) {
        // If the marker is draggable add a listener so we update the clusters on
        // the drag end.
        var that = this;
        google.maps.event.addListener(marker, 'dragend', function () {
            marker.isAdded = false;
            that.repaint();
        });
    }
    this.markers_.push(marker);
};


/**
 * Adds a marker to the clusterer and redraws if needed.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @param {boolean=} opt_nodraw Whether to redraw the clusters.
 */
MarkerClusterer.prototype.addMarker = function (marker, opt_nodraw) {
    this.pushMarkerTo_(marker);
    if (!opt_nodraw) {
        this.redraw();
    }
};


/**
 * Removes a marker and returns true if removed, false if not
 *
 * @param {google.maps.Marker} marker The marker to remove
 * @return {boolean} Whether the marker was removed or not
 * @private
 */
MarkerClusterer.prototype.removeMarker_ = function (marker) {
    var index = -1;
    if (this.markers_.indexOf) {
        index = this.markers_.indexOf(marker);
    } else {
        for (var i = 0, m; m = this.markers_[i]; i++) {
            if (m == marker) {
                index = i;
                break;
            }
        }
    }

    if (index == -1) {
        // Marker is not in our list of markers.
        return false;
    }

    marker.setMap(null);

    this.markers_.splice(index, 1);

    return true;
};


/**
 * Remove a marker from the cluster.
 *
 * @param {google.maps.Marker} marker The marker to remove.
 * @param {boolean=} opt_nodraw Optional boolean to force no redraw.
 * @return {boolean} True if the marker was removed.
 */
MarkerClusterer.prototype.removeMarker = function (marker, opt_nodraw) {
    var removed = this.removeMarker_(marker);

    if (!opt_nodraw && removed) {
        this.resetViewport();
        this.redraw();
        return true;
    } else {
        return false;
    }
};


/**
 * Removes an array of markers from the cluster.
 *
 * @param {Array.<google.maps.Marker>} markers The markers to remove.
 * @param {boolean=} opt_nodraw Optional boolean to force no redraw.
 */
MarkerClusterer.prototype.removeMarkers = function (markers, opt_nodraw) {
    var removed = false;

    for (var i = 0, marker; marker = markers[i]; i++) {
        var r = this.removeMarker_(marker);
        removed = removed || r;
    }

    if (!opt_nodraw && removed) {
        this.resetViewport();
        this.redraw();
        return true;
    }
};


/**
 * Sets the clusterer's ready state.
 *
 * @param {boolean} ready The state.
 * @private
 */
MarkerClusterer.prototype.setReady_ = function (ready) {
    if (!this.ready_) {
        this.ready_ = ready;
        this.createClusters_();
    }
};


/**
 * Returns the number of clusters in the clusterer.
 *
 * @return {number} The number of clusters.
 */
MarkerClusterer.prototype.getTotalClusters = function () {
    return this.clusters_.length;
};


/**
 * Returns the google map that the clusterer is associated with.
 *
 * @return {google.maps.Map} The map.
 */
MarkerClusterer.prototype.getMap = function () {
    return this.map_;
};


/**
 * Sets the google map that the clusterer is associated with.
 *
 * @param {google.maps.Map} map The map.
 */
MarkerClusterer.prototype.setMap = function (map) {
    this.map_ = map;
};


/**
 * Returns the size of the grid.
 *
 * @return {number} The grid size.
 */
MarkerClusterer.prototype.getGridSize = function () {
    return this.gridSize_;
};


/**
 * Sets the size of the grid.
 *
 * @param {number} size The grid size.
 */
MarkerClusterer.prototype.setGridSize = function (size) {
    this.gridSize_ = size;
};


/**
 * Returns the min cluster size.
 *
 * @return {number} The grid size.
 */
MarkerClusterer.prototype.getMinClusterSize = function () {
    return this.minClusterSize_;
};

/**
 * Sets the min cluster size.
 *
 * @param {number} size The grid size.
 */
MarkerClusterer.prototype.setMinClusterSize = function (size) {
    this.minClusterSize_ = size;
};


/**
 * Extends a bounds object by the grid size.
 *
 * @param {google.maps.LatLngBounds} bounds The bounds to extend.
 * @return {google.maps.LatLngBounds} The extended bounds.
 */
MarkerClusterer.prototype.getExtendedBounds = function (bounds) {
    var projection = this.getProjection();

    // Turn the bounds into latlng.
    var tr = new google.maps.LatLng(bounds.getNorthEast().lat(),
        bounds.getNorthEast().lng());
    var bl = new google.maps.LatLng(bounds.getSouthWest().lat(),
        bounds.getSouthWest().lng());

    // Convert the points to pixels and the extend out by the grid size.
    var trPix = projection.fromLatLngToDivPixel(tr);
    trPix.x += this.gridSize_;
    trPix.y -= this.gridSize_;

    var blPix = projection.fromLatLngToDivPixel(bl);
    blPix.x -= this.gridSize_;
    blPix.y += this.gridSize_;

    // Convert the pixel points back to LatLng
    var ne = projection.fromDivPixelToLatLng(trPix);
    var sw = projection.fromDivPixelToLatLng(blPix);

    // Extend the bounds to contain the new bounds.
    bounds.extend(ne);
    bounds.extend(sw);

    return bounds;
};


/**
 * Determins if a marker is contained in a bounds.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @param {google.maps.LatLngBounds} bounds The bounds to check against.
 * @return {boolean} True if the marker is in the bounds.
 * @private
 */
MarkerClusterer.prototype.isMarkerInBounds_ = function (marker, bounds) {
    return bounds.contains(marker.getPosition());
};


/**
 * Clears all clusters and markers from the clusterer.
 */
MarkerClusterer.prototype.clearMarkers = function () {
    this.resetViewport(true);

    // Set the markers a empty array.
    this.markers_ = [];
};


/**
 * Clears all existing clusters and recreates them.
 * @param {boolean} opt_hide To also hide the marker.
 */
MarkerClusterer.prototype.resetViewport = function (opt_hide) {
    // Remove all the clusters
    for (var i = 0, cluster; cluster = this.clusters_[i]; i++) {
        cluster.remove();
    }

    // Reset the markers to not be added and to be invisible.
    for (var i = 0, marker; marker = this.markers_[i]; i++) {
        marker.isAdded = false;
        if (opt_hide) {
            marker.setMap(null);
        }
    }

    this.clusters_ = [];
};

/**
 *
 */
MarkerClusterer.prototype.repaint = function () {
    var oldClusters = this.clusters_.slice();
    this.clusters_.length = 0;
    this.resetViewport();
    this.redraw();

    // Remove the old clusters.
    // Do it in a timeout so the other clusters have been drawn first.
    window.setTimeout(function () {
        for (var i = 0, cluster; cluster = oldClusters[i]; i++) {
            cluster.remove();
        }
    }, 0);
};


/**
 * Redraws the clusters.
 */
MarkerClusterer.prototype.redraw = function () {
    this.createClusters_();
};


/**
 * Calculates the distance between two latlng locations in km.
 * @see http://www.movable-type.co.uk/scripts/latlong.html
 *
 * @param {google.maps.LatLng} p1 The first lat lng point.
 * @param {google.maps.LatLng} p2 The second lat lng point.
 * @return {number} The distance between the two points in km.
 * @private
*/
MarkerClusterer.prototype.distanceBetweenPoints_ = function (p1, p2) {
    if (!p1 || !p2) {
        return 0;
    }

    var R = 6371; // Radius of the Earth in km
    var dLat = (p2.lat() - p1.lat()) * Math.PI / 180;
    var dLon = (p2.lng() - p1.lng()) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(p1.lat() * Math.PI / 180) * Math.cos(p2.lat() * Math.PI / 180) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d;
};


/**
 * Add a marker to a cluster, or creates a new cluster.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @private
 */
MarkerClusterer.prototype.addToClosestCluster_ = function (marker) {
    var distance = 40000; // Some large number
    var clusterToAddTo = null;
    var pos = marker.getPosition();
    for (var i = 0, cluster; cluster = this.clusters_[i]; i++) {
        var center = cluster.getCenter();
        if (center) {
            var d = this.distanceBetweenPoints_(center, marker.getPosition());
            if (d < distance) {
                distance = d;
                clusterToAddTo = cluster;
            }
        }
    }

    if (clusterToAddTo && clusterToAddTo.isMarkerInClusterBounds(marker)) {
        clusterToAddTo.addMarker(marker);
    } else {
        var cluster = new Cluster(this);
        cluster.addMarker(marker);
        this.clusters_.push(cluster);
    }
};


/**
 * Creates the clusters.
 *
 * @private
 */
MarkerClusterer.prototype.createClusters_ = function () {
    if (!this.ready_) {
        return;
    }

    // Get our current map view bounds.
    // Create a new bounds object so we don't affect the map.
    var mapBounds = new google.maps.LatLngBounds(this.map_.getBounds().getSouthWest(),
        this.map_.getBounds().getNorthEast());
    var bounds = this.getExtendedBounds(mapBounds);

    for (var i = 0, marker; marker = this.markers_[i]; i++) {
        if (!marker.isAdded && this.isMarkerInBounds_(marker, bounds)) {
            this.addToClosestCluster_(marker);
        }
    }
};


/**
 * A cluster that contains markers.
 *
 * @param {MarkerClusterer} markerClusterer The markerclusterer that this
 *     cluster is associated with.
 * @constructor
 * @ignore
 */
function Cluster(markerClusterer) {
    this.markerClusterer_ = markerClusterer;
    this.map_ = markerClusterer.getMap();
    this.gridSize_ = markerClusterer.getGridSize();
    this.minClusterSize_ = markerClusterer.getMinClusterSize();
    this.averageCenter_ = markerClusterer.isAverageCenter();
    this.center_ = null;
    this.markers_ = [];
    this.bounds_ = null;
    this.clusterIcon_ = new ClusterIcon(this, markerClusterer.getStyles(),
        markerClusterer.getGridSize());
}

/**
 * Determins if a marker is already added to the cluster.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @return {boolean} True if the marker is already added.
 */
Cluster.prototype.isMarkerAlreadyAdded = function (marker) {
    if (this.markers_.indexOf) {
        return this.markers_.indexOf(marker) != -1;
    } else {
        for (var i = 0, m; m = this.markers_[i]; i++) {
            if (m == marker) {
                return true;
            }
        }
    }
    return false;
};


/**
 * Add a marker the cluster.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @return {boolean} True if the marker was added.
 */
Cluster.prototype.addMarker = function (marker) {
    if (this.isMarkerAlreadyAdded(marker)) {
        return false;
    }

    if (!this.center_) {
        this.center_ = marker.getPosition();
        this.calculateBounds_();
    } else {
        if (this.averageCenter_) {
            var l = this.markers_.length + 1;
            var lat = (this.center_.lat() * (l - 1) + marker.getPosition().lat()) / l;
            var lng = (this.center_.lng() * (l - 1) + marker.getPosition().lng()) / l;
            this.center_ = new google.maps.LatLng(lat, lng);
            this.calculateBounds_();
        }
    }

    marker.isAdded = true;
    this.markers_.push(marker);

    var len = this.markers_.length;
    if (len < this.minClusterSize_ && marker.getMap() != this.map_) {
        // Min cluster size not reached so show the marker.
        marker.setMap(this.map_);
    }

    if (len == this.minClusterSize_) {
        // Hide the markers that were showing.
        for (var i = 0; i < len; i++) {
            this.markers_[i].setMap(null);
        }
    }

    if (len >= this.minClusterSize_) {
        marker.setMap(null);
    }

    this.updateIcon();
    return true;
};


/**
 * Returns the marker clusterer that the cluster is associated with.
 *
 * @return {MarkerClusterer} The associated marker clusterer.
 */
Cluster.prototype.getMarkerClusterer = function () {
    return this.markerClusterer_;
};


/**
 * Returns the bounds of the cluster.
 *
 * @return {google.maps.LatLngBounds} the cluster bounds.
 */
Cluster.prototype.getBounds = function () {
    var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
    var markers = this.getMarkers();
    for (var i = 0, marker; marker = markers[i]; i++) {
        bounds.extend(marker.getPosition());
    }
    return bounds;
};


/**
 * Removes the cluster
 */
Cluster.prototype.remove = function () {
    this.clusterIcon_.remove();
    this.markers_.length = 0;
    delete this.markers_;
};


/**
 * Returns the center of the cluster.
 *
 * @return {number} The cluster center.
 */
Cluster.prototype.getSize = function () {
    return this.markers_.length;
};


/**
 * Returns the center of the cluster.
 *
 * @return {Array.<google.maps.Marker>} The cluster center.
 */
Cluster.prototype.getMarkers = function () {
    return this.markers_;
};


/**
 * Returns the center of the cluster.
 *
 * @return {google.maps.LatLng} The cluster center.
 */
Cluster.prototype.getCenter = function () {
    return this.center_;
};


/**
 * Calculated the extended bounds of the cluster with the grid.
 *
 * @private
 */
Cluster.prototype.calculateBounds_ = function () {
    var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
    this.bounds_ = this.markerClusterer_.getExtendedBounds(bounds);
};


/**
 * Determines if a marker lies in the clusters bounds.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @return {boolean} True if the marker lies in the bounds.
 */
Cluster.prototype.isMarkerInClusterBounds = function (marker) {
    return this.bounds_.contains(marker.getPosition());
};


/**
 * Returns the map that the cluster is associated with.
 *
 * @return {google.maps.Map} The map.
 */
Cluster.prototype.getMap = function () {
    return this.map_;
};


/**
 * Updates the cluster icon
 */
Cluster.prototype.updateIcon = function () {
    var zoom = this.map_.getZoom();
    var mz = this.markerClusterer_.getMaxZoom();

    if (mz && zoom > mz) {
        // The zoom is greater than our max zoom so show all the markers in cluster.
        for (var i = 0, marker; marker = this.markers_[i]; i++) {
            marker.setMap(this.map_);
        }
        return;
    }

    if (this.markers_.length < this.minClusterSize_) {
        // Min cluster size not yet reached.
        this.clusterIcon_.hide();
        return;
    }

    var numStyles = this.markerClusterer_.getStyles().length;
    var sums = this.markerClusterer_.getCalculator()(this.markers_, numStyles);
    this.clusterIcon_.setCenter(this.center_);
    this.clusterIcon_.setSums(sums);
    this.clusterIcon_.show();
};


/**
 * A cluster icon
 *
 * @param {Cluster} cluster The cluster to be associated with.
 * @param {Object} styles An object that has style properties:
 *     'url': (string) The image url.
 *     'height': (number) The image height.
 *     'width': (number) The image width.
 *     'anchor': (Array) The anchor position of the label text.
 *     'textColor': (string) The text color.
 *     'textSize': (number) The text size.
 *     'backgroundPosition: (string) The background postition x, y.
 * @param {number=} opt_padding Optional padding to apply to the cluster icon.
 * @constructor
 * @extends google.maps.OverlayView
 * @ignore
 */
function ClusterIcon(cluster, styles, opt_padding) {
    cluster.getMarkerClusterer().extend(ClusterIcon, google.maps.OverlayView);

    this.styles_ = styles;
    this.padding_ = opt_padding || 0;
    this.cluster_ = cluster;
    this.center_ = null;
    this.map_ = cluster.getMap();
    this.div_ = null;
    this.sums_ = null;
    this.visible_ = false;

    this.setMap(this.map_);
}


/**
 * Triggers the clusterclick event and zoom's if the option is set.
 *
 * @param {google.maps.MouseEvent} event The event to propagate
 */
ClusterIcon.prototype.triggerClusterClick = function (event) {
    var markerClusterer = this.cluster_.getMarkerClusterer();

    // Trigger the clusterclick event.
    google.maps.event.trigger(markerClusterer, 'clusterclick', this.cluster_, event);

    if (markerClusterer.isZoomOnClick()) {
        // Zoom into the cluster.
        this.map_.fitBounds(this.cluster_.getBounds());
    }
};


/**
 * Adding the cluster icon to the dom.
 * @ignore
 */
ClusterIcon.prototype.onAdd = function () {
    this.div_ = document.createElement('DIV');
    if (this.visible_) {
        var pos = this.getPosFromLatLng_(this.center_);
        this.div_.style.cssText = this.createCss(pos);
        this.div_.innerHTML = this.sums_.text;
    }

    var panes = this.getPanes();
    panes.overlayMouseTarget.appendChild(this.div_);

    var that = this;
    var isDragging = false;
    google.maps.event.addDomListener(this.div_, 'click', function (event) {
        // Only perform click when not preceded by a drag
        if (!isDragging) {
            that.triggerClusterClick(event);
        }
    });
    google.maps.event.addDomListener(this.div_, 'mousedown', function () {
        isDragging = false;
    });
    google.maps.event.addDomListener(this.div_, 'mousemove', function () {
        isDragging = true;
    });
};


/**
 * Returns the position to place the div dending on the latlng.
 *
 * @param {google.maps.LatLng} latlng The position in latlng.
 * @return {google.maps.Point} The position in pixels.
 * @private
 */
ClusterIcon.prototype.getPosFromLatLng_ = function (latlng) {
    var pos = this.getProjection().fromLatLngToDivPixel(latlng);

    if (typeof this.iconAnchor_ === 'object' && this.iconAnchor_.length === 2) {
        pos.x -= this.iconAnchor_[0];
        pos.y -= this.iconAnchor_[1];
    } else {
        pos.x -= parseInt(this.width_ / 2, 10);
        pos.y -= parseInt(this.height_ / 2, 10);
    }
    return pos;
};


/**
 * Draw the icon.
 * @ignore
 */
ClusterIcon.prototype.draw = function () {
    if (this.visible_) {
        var pos = this.getPosFromLatLng_(this.center_);
        this.div_.style.top = pos.y + 'px';
        this.div_.style.left = pos.x + 'px';
    }
};


/**
 * Hide the icon.
 */
ClusterIcon.prototype.hide = function () {
    if (this.div_) {
        this.div_.style.display = 'none';
    }
    this.visible_ = false;
};


/**
 * Position and show the icon.
 */
ClusterIcon.prototype.show = function () {
    if (this.div_) {
        var pos = this.getPosFromLatLng_(this.center_);
        this.div_.style.cssText = this.createCss(pos);
        this.div_.style.display = '';
    }
    this.visible_ = true;
};


/**
 * Remove the icon from the map
 */
ClusterIcon.prototype.remove = function () {
    this.setMap(null);
};


/**
 * Implementation of the onRemove interface.
 * @ignore
 */
ClusterIcon.prototype.onRemove = function () {
    if (this.div_ && this.div_.parentNode) {
        this.hide();
        this.div_.parentNode.removeChild(this.div_);
        this.div_ = null;
    }
};


/**
 * Set the sums of the icon.
 *
 * @param {Object} sums The sums containing:
 *   'text': (string) The text to display in the icon.
 *   'index': (number) The style index of the icon.
 */
ClusterIcon.prototype.setSums = function (sums) {
    this.sums_ = sums;
    this.text_ = sums.text;
    this.index_ = sums.index;
    if (this.div_) {
        this.div_.innerHTML = sums.text;
    }

    this.useStyle();
};


/**
 * Sets the icon to the the styles.
 */
ClusterIcon.prototype.useStyle = function () {
    var index = Math.max(0, this.sums_.index - 1);
    index = Math.min(this.styles_.length - 1, index);
    var style = this.styles_[index];
    this.url_ = style['url'];
    this.height_ = style['height'];
    this.width_ = style['width'];
    this.textColor_ = style['textColor'];
    this.anchor_ = style['anchor'];
    this.textSize_ = style['textSize'];
    this.backgroundPosition_ = style['backgroundPosition'];
    this.iconAnchor_ = style['iconAnchor'];
};


/**
 * Sets the center of the icon.
 *
 * @param {google.maps.LatLng} center The latlng to set as the center.
 */
ClusterIcon.prototype.setCenter = function (center) {
    this.center_ = center;
};


/**
 * Create the css text based on the position of the icon.
 *
 * @param {google.maps.Point} pos The position.
 * @return {string} The css style text.
 */
ClusterIcon.prototype.createCss = function (pos) {
    var style = [];
    style.push('background-image:url(' + this.url_ + ');');
    var backgroundPosition = this.backgroundPosition_ ? this.backgroundPosition_ : '0 0';
    style.push('background-position:' + backgroundPosition + ';');

    if (typeof this.anchor_ === 'object') {
        if (typeof this.anchor_[0] === 'number' && this.anchor_[0] > 0 &&
            this.anchor_[0] < this.height_) {
            style.push('height:' + (this.height_ - this.anchor_[0]) +
                'px; padding-top:' + this.anchor_[0] + 'px;');
        } else if (typeof this.anchor_[0] === 'number' && this.anchor_[0] < 0 &&
            -this.anchor_[0] < this.height_) {
            style.push('height:' + this.height_ + 'px; line-height:' + (this.height_ + this.anchor_[0]) +
                'px;');
        } else {
            style.push('height:' + this.height_ + 'px; line-height:' + this.height_ +
                'px;');
        }
        if (typeof this.anchor_[1] === 'number' && this.anchor_[1] > 0 &&
            this.anchor_[1] < this.width_) {
            style.push('width:' + (this.width_ - this.anchor_[1]) +
                'px; padding-left:' + this.anchor_[1] + 'px;');
        } else {
            style.push('width:' + this.width_ + 'px; text-align:center;');
        }
    } else {
        style.push('height:' + this.height_ + 'px; line-height:' +
            this.height_ + 'px; width:' + this.width_ + 'px; text-align:center;');
    }

    var txtColor = this.textColor_ ? this.textColor_ : 'black';
    var txtSize = this.textSize_ ? this.textSize_ : 11;

    style.push('cursor:pointer; top:' + pos.y + 'px; left:' +
        pos.x + 'px; color:' + txtColor + '; position:absolute; font-size:' +
        txtSize + 'px; font-family:Arial,sans-serif; font-weight:bold');
    return style.join('');
};


// Export Symbols for Closure
// If you are not going to compile with closure then you can remove the
// code below.
window['MarkerClusterer'] = MarkerClusterer;
MarkerClusterer.prototype['addMarker'] = MarkerClusterer.prototype.addMarker;
MarkerClusterer.prototype['addMarkers'] = MarkerClusterer.prototype.addMarkers;
MarkerClusterer.prototype['clearMarkers'] =
    MarkerClusterer.prototype.clearMarkers;
MarkerClusterer.prototype['fitMapToMarkers'] =
    MarkerClusterer.prototype.fitMapToMarkers;
MarkerClusterer.prototype['getCalculator'] =
    MarkerClusterer.prototype.getCalculator;
MarkerClusterer.prototype['getGridSize'] =
    MarkerClusterer.prototype.getGridSize;
MarkerClusterer.prototype['getExtendedBounds'] =
    MarkerClusterer.prototype.getExtendedBounds;
MarkerClusterer.prototype['getMap'] = MarkerClusterer.prototype.getMap;
MarkerClusterer.prototype['getMarkers'] = MarkerClusterer.prototype.getMarkers;
MarkerClusterer.prototype['getMaxZoom'] = MarkerClusterer.prototype.getMaxZoom;
MarkerClusterer.prototype['getStyles'] = MarkerClusterer.prototype.getStyles;
MarkerClusterer.prototype['getTotalClusters'] =
    MarkerClusterer.prototype.getTotalClusters;
MarkerClusterer.prototype['getTotalMarkers'] =
    MarkerClusterer.prototype.getTotalMarkers;
MarkerClusterer.prototype['redraw'] = MarkerClusterer.prototype.redraw;
MarkerClusterer.prototype['removeMarker'] =
    MarkerClusterer.prototype.removeMarker;
MarkerClusterer.prototype['removeMarkers'] =
    MarkerClusterer.prototype.removeMarkers;
MarkerClusterer.prototype['resetViewport'] =
    MarkerClusterer.prototype.resetViewport;
MarkerClusterer.prototype['repaint'] =
    MarkerClusterer.prototype.repaint;
MarkerClusterer.prototype['setCalculator'] =
    MarkerClusterer.prototype.setCalculator;
MarkerClusterer.prototype['setGridSize'] =
    MarkerClusterer.prototype.setGridSize;
MarkerClusterer.prototype['setMaxZoom'] =
    MarkerClusterer.prototype.setMaxZoom;
MarkerClusterer.prototype['onAdd'] = MarkerClusterer.prototype.onAdd;
MarkerClusterer.prototype['draw'] = MarkerClusterer.prototype.draw;

Cluster.prototype['getCenter'] = Cluster.prototype.getCenter;
Cluster.prototype['getSize'] = Cluster.prototype.getSize;
Cluster.prototype['getMarkers'] = Cluster.prototype.getMarkers;

ClusterIcon.prototype['onAdd'] = ClusterIcon.prototype.onAdd;
ClusterIcon.prototype['draw'] = ClusterIcon.prototype.draw;
ClusterIcon.prototype['onRemove'] = ClusterIcon.prototype.onRemove;


jQuery(document).on('keyup', '#search-product', function () {
    jQuery('.search-result').addClass('active');
    jQuery('body').addClass('noScroll');
    var value = jQuery(this).val();
    var verification_nonce = jQuery(this).attr('data_nonce');
    let value_trim = value.replace(/\s/g, '')
    let timeout;
    if (value_trim.length > 2) {
        clearTimeout(timeout);
        timeout = setTimeout(function () {
            jQuery.ajax({
                url: wc_add_to_cart_params.ajax_url,
                type: 'post',
                data: {
                    action: 'ajax_search',
                    search: value,
                    prevent_other: 1,
                    verification_nonce: verification_nonce
                },
                success: function (response) {
                    jQuery('.search-result__wrap').html(response);
                }
            });
        }, 2000);
    } else {
        jQuery('.search-result').removeClass('active');
        // jQuery('body').removeClass('noScroll');     
        jQuery('.search-result__wrap').html('<h3 class="title-ajax-search">Stiamo caricando i risultati...</h3><div class="loader-search simple-circle"></div>');
    }
})



jQuery(document).on('click', '.send-newsletter', function (e) {
    e.preventDefault();
    let email = jQuery('#email').val();
    if (isEmail(email)) {
        var data = {
            'action': 'subscribe_user',
            'email': email,
            'security': aw.security
        };

        jQuery.post(aw.ajaxurl, data, function (response) {
            if (response == 200) {
                jQuery(".input-newsletter").prop("value", "Grazie conferma la tua iscrizione!");
            } else {
                jQuery(".input-newsletter").prop("value", response);
            }
        });
    } else {
        jQuery(".input-newsletter").prop("value", 'L\'email non è valida');
    }
});


function isEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}